

// ////old code 
// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   doc,
//   getDoc,
//   setDoc,
//   updateDoc,
//   collection,
//   addDoc,
//   serverTimestamp,
//   increment
// } from 'firebase/firestore';
// import { db, auth } from '../../firebase/firebaseConfig';
// import { onAuthStateChanged } from 'firebase/auth';
// import './Checkout.css';

// // Google Maps API key - using the same one from the Header component
// const GOOGLE_MAPS_API_KEY = 'AIzaSyA5ReIwel6soo1uIWWRvAIdIubZQKnbjfc';

// const Checkout = () => {
//   const [cartItems, setCartItems] = useState([]);
//   const [paymentMethod, setPaymentMethod] = useState('');
//   const [deliveryAddress, setDeliveryAddress] = useState('');
//   const [name, setName] = useState('');
//   const [phone, setPhone] = useState('');
//   const [email, setEmail] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [userId, setUserId] = useState(null);
//   const [userData, setUserData] = useState({});
//   const [formErrors, setFormErrors] = useState({});
//   const [isFormValid, setIsFormValid] = useState(false);
//   const navigate = useNavigate();
//   const [deliveryCharge, setDeliveryCharge] = useState(0);
//   const [pointsEarned, setPointsEarned] = useState(0);
//   const [deliveryDistance, setDeliveryDistance] = useState(0);
//   const [isCalculatingDelivery, setIsCalculatingDelivery] = useState(false);
//   const [deliveryError, setDeliveryError] = useState('');

//   // New state variables for location fetching
//   const [isLocating, setIsLocating] = useState(false);
//   const [locationError, setLocationError] = useState('');
//   const [fullAddressData, setFullAddressData] = useState(null);

//   const INVENTORY_LOCATION = "SP Road, Bangalore North, Bangalore, Karnataka 560002, India";
//   const DELIVERY_RATE_PER_KM = 45;
//   const BASE_DELIVERY_CHARGE = 50; // Minimum delivery charge
//   const MAX_DELIVERY_CHARGE = 500; // Maximum delivery charge
//   const FREE_DELIVERY_THRESHOLD = 2000; // Free delivery above this amount

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         setUserId(user.uid);
//         fetchUserData(user.uid);
//         fetchCartFromFirestore(user.uid);
//       } else {
//         setUserId(null);
//         fetchCartFromLocalStorage();
//         loadUserDataFromLocalStorage();
//       }
//     });
//     return () => unsubscribe();
//   }, []);

//   useEffect(() => {
//     const handleCartUpdate = () => {
//       console.log("Cart update detected in Checkout");
//       if (userId) {
//         fetchCartFromFirestore(userId);
//       } else {
//         fetchCartFromLocalStorage();
//       }
//     };
//     window.addEventListener('cartUpdated', handleCartUpdate);
//     return () => window.removeEventListener('cartUpdated', handleCartUpdate);
//   }, [userId]);

//   useEffect(() => {
//     validateForm();
//     calculatePointsEarned();
//   }, [name, phone, email, deliveryAddress, paymentMethod, cartItems]);

//   // Get detailed address from coordinates
//   const getDetailedAddressFromCoordinates = async (latitude, longitude) => {
//     try {
//       const response = await fetch(
//         `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_MAPS_API_KEY}`
//       );

//       if (!response.ok) {
//         throw new Error('Google Geocoding API error');
//       }

//       const data = await response.json();

//       if (data.status !== 'OK' || !data.results || data.results.length === 0) {
//         throw new Error('No address found for this location');
//       }

//       const fullResult = data.results[0];
//       const formattedAddress = fullResult.formatted_address;

//       // For a more concise display address in UI if needed
//       const displayAddress = formattedAddress.split(',').slice(0, 3).join(',');

//       return {
//         fullAddress: formattedAddress,
//         formattedAddress: formattedAddress, // Using full address for delivery
//         latitude,
//         longitude
//       };
//     } catch (googleError) {
//       console.error("Error with Google Geocoding:", googleError);
//       try {
//         // Fallback to another geocoding service
//         const response = await fetch(
//           `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
//         );

//         if (!response.ok) {
//           throw new Error('Geocoding API error');
//         }

//         const data = await response.json();
//         const locality = data.locality || '';
//         const district = data.localityInfo?.administrative?.find(a => a.adminLevel === 6)?.name || '';
//         const subDistrict = data.localityInfo?.administrative?.find(a => a.adminLevel === 8)?.name || '';
//         const road = data.road || '';
//         const street = data.street || '';
//         const city = data.city || data.locality || 'Bengaluru';
//         const state = data.principalSubdivision || 'Karnataka';
//         const country = data.countryName || 'India';
//         const postalCode = data.postcode || '';

//         // Construct a more complete address from the components
//         const addressComponents = [
//           road || street,
//           locality,
//           subDistrict,
//           district,
//           city,
//           state,
//           country,
//           postalCode
//         ].filter(Boolean);

//         const formattedAddress = addressComponents.join(', ');

//         return {
//           fullAddress: formattedAddress,
//           formattedAddress: formattedAddress,
//           latitude,
//           longitude,
//           city,
//           state
//         };
//       } catch (fallbackError) {
//         console.error("Error in fallback geocoding:", fallbackError);
//         throw new Error('Could not determine your location. Please try again or enter your address manually.');
//       }
//     }
//   };

//   // Handle using current location
//   const handleUseCurrentLocation = () => {
//     if (navigator.geolocation) {
//       setIsLocating(true);
//       setLocationError('');

//       navigator.geolocation.getCurrentPosition(
//         async (position) => {
//           try {
//             const { latitude, longitude } = position.coords;
//             const addressData = await getDetailedAddressFromCoordinates(latitude, longitude);

//             // Set address in form
//             setDeliveryAddress(addressData.fullAddress);
//             setFullAddressData(addressData);

//             // Store in localStorage for future use
//             try {
//               localStorage.setItem('userLocation', JSON.stringify(addressData));
//             } catch (error) {
//               console.error("Error saving to localStorage:", error);
//             }

//             setIsLocating(false);
//           } catch (error) {
//             console.error("Error getting detailed address:", error);
//             setLocationError(error.message);
//             setIsLocating(false);
//           }
//         },
//         (error) => {
//           console.error("Geolocation error:", error);
//           let errorMessage = 'Unable to detect location';

//           if (error.code === 1) {
//             errorMessage = 'Location access denied. Please enable location services.';
//           } else if (error.code === 2) {
//             errorMessage = 'Location unavailable. Please try again later.';
//           } else if (error.code === 3) {
//             errorMessage = 'Location request timed out. Please try again.';
//           }

//           setLocationError(errorMessage);
//           setIsLocating(false);
//         },
//         {
//           enableHighAccuracy: true,
//           timeout: 10000,
//           maximumAge: 0
//         }
//       );
//     } else {
//       setLocationError('Geolocation is not supported by your browser');
//     }
//   };

//   // Debounced delivery calculation
//   const calculateDeliveryCharges = useCallback(
//     debounce(async (address) => {
//       if (!address || !address.trim()) {
//         setDeliveryDistance(0);
//         setDeliveryCharge(0);
//         setDeliveryError('');
//         return;
//       }

//       setIsCalculatingDelivery(true);
//       setDeliveryError('');

//       try {
//         // First, try to calculate using a more reliable method
//         const distance = await calculateDistanceUsingGeocoding(address);

//         if (distance > 0) {
//           const calculatedCharge = calculateDeliveryFee(distance);
//           setDeliveryDistance(distance);
//           setDeliveryCharge(calculatedCharge);
//           console.log(`Distance: ${distance.toFixed(1)} km, Charge: ₹${calculatedCharge}`);
//         } else {
//           // Fallback to estimated charges based on location patterns
//           const estimatedCharge = estimateDeliveryCharge(address);
//           setDeliveryDistance(0);
//           setDeliveryCharge(estimatedCharge);

//         }
//       } catch (error) {
//         console.error('Error calculating delivery charges:', error);
//         const estimatedCharge = estimateDeliveryCharge(address);
//         setDeliveryDistance(0);
//         setDeliveryCharge(estimatedCharge);
//         setDeliveryError('Using estimated delivery charges due to calculation error.');
//       } finally {
//         setIsCalculatingDelivery(false);
//       }
//     }, 1000),
//     []
//   );

//   useEffect(() => {
//     if (deliveryAddress) {
//       calculateDeliveryCharges(deliveryAddress);
//     }
//   }, [deliveryAddress, calculateDeliveryCharges]);

//   // Debounce function
//   function debounce(func, wait) {
//     let timeout;
//     return function executedFunction(...args) {
//       const later = () => {
//         clearTimeout(timeout);
//         func(...args);
//       };
//       clearTimeout(timeout);
//       timeout = setTimeout(later, wait);
//     };
//   }

//   // More reliable distance calculation using geocoding
//   const calculateDistanceUsingGeocoding = async (address) => {
//     try {
//       // Use a geocoding service to get coordinates
//       const response = await fetch(
//         `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(address)}&key=YOUR_OPENCAGE_API_KEY&countrycode=IN&limit=1`
//       );

//       if (!response.ok) {
//         throw new Error('Geocoding service unavailable');
//       }

//       const data = await response.json();

//       if (data.results && data.results.length > 0) {
//         const { lat, lng } = data.results[0].geometry;

//         // SP Road coordinates (approximate)
//         const spRoadLat = 13.0067;
//         const spRoadLng = 77.5667;

//         const distance = calculateHaversineDistance(spRoadLat, spRoadLng, lat, lng);
//         return distance;
//       }

//       return 0;
//     } catch (error) {
//       console.error('Error in geocoding:', error);
//       return 0;
//     }
//   };

//   // Haversine formula for distance calculation
//   const calculateHaversineDistance = (lat1, lon1, lat2, lon2) => {
//     const R = 6371; // Radius of the Earth in kilometers
//     const dLat = (lat2 - lat1) * Math.PI / 180;
//     const dLon = (lon2 - lon1) * Math.PI / 180;
//     const a =
//       Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//       Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
//       Math.sin(dLon / 2) * Math.sin(dLon / 2);
//     const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//     const distance = R * c;
//     return distance;
//   };

//   // Calculate delivery fee based on distance
//   const calculateDeliveryFee = (distance) => {
//     const subtotal = calculateSubtotal();

//     // Free delivery for orders above threshold
//     if (subtotal >= FREE_DELIVERY_THRESHOLD) {
//       return 0;
//     }

//     let charge = Math.max(BASE_DELIVERY_CHARGE, Math.ceil(distance * DELIVERY_RATE_PER_KM));
//     return Math.min(charge, MAX_DELIVERY_CHARGE);
//   };

//   // Estimate delivery charge based on location patterns
//   const estimateDeliveryCharge = (address) => {
//     const subtotal = calculateSubtotal();

//     // Free delivery for orders above threshold
//     if (subtotal >= FREE_DELIVERY_THRESHOLD) {
//       return 0;
//     }

//     const lowerAddress = address.toLowerCase();

//     // Bangalore city center areas (closer to SP Road)
//     if (lowerAddress.includes('mg road') ||
//       lowerAddress.includes('brigade road') ||
//       lowerAddress.includes('commercial street') ||
//       lowerAddress.includes('chickpet') ||
//       lowerAddress.includes('gandhi nagar') ||
//       lowerAddress.includes('rajajinagar') ||
//       lowerAddress.includes('basavanagudi') ||
//       lowerAddress.includes('malleshwaram')) {
//       return 80;
//     }

//     // Nearby areas
//     if (lowerAddress.includes('koramangala') ||
//       lowerAddress.includes('indiranagar') ||
//       lowerAddress.includes('whitefield') ||
//       lowerAddress.includes('hsr layout') ||
//       lowerAddress.includes('btm layout') ||
//       lowerAddress.includes('jp nagar') ||
//       lowerAddress.includes('banashankari') ||
//       lowerAddress.includes('vijayanagar')) {
//       return 120;
//     }

//     // Outer Bangalore areas
//     if (lowerAddress.includes('electronic city') ||
//       lowerAddress.includes('sarjapur') ||
//       lowerAddress.includes('marathahalli') ||
//       lowerAddress.includes('hebbal') ||
//       lowerAddress.includes('yelahanka') ||
//       lowerAddress.includes('bommanahalli') ||
//       lowerAddress.includes('bannerghatta') ||
//       lowerAddress.includes('kengeri')) {
//       return 180;
//     }

//     // Default charge for other Bangalore areas
//     if (lowerAddress.includes('bangalore') ||
//       lowerAddress.includes('bengaluru') ||
//       lowerAddress.includes('karnataka')) {
//       return 150;
//     }

//     // Outside Bangalore
//     return 250;
//   };

//   const fetchUserData = async (uid) => {
//     try {
//       const userRef = doc(db, 'users', uid);
//       const userSnap = await getDoc(userRef);
//       if (userSnap.exists()) {
//         const data = userSnap.data();
//         setUserData(data);
//         setName(data.name || '');
//         setPhone(data.phone || '');
//         setEmail(data.email || '');
//         if (data.deliveryAddress) {
//           setDeliveryAddress(data.deliveryAddress);
//         } else {
//           loadDeliveryAddress();
//         }
//       } else {
//         console.log("No user data found");
//         loadDeliveryAddress();
//         loadUserDataFromLocalStorage();
//       }
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//       loadDeliveryAddress();
//       loadUserDataFromLocalStorage();
//     }
//   };

//   const loadDeliveryAddress = () => {
//     const savedLocation = localStorage.getItem('userLocation');
//     if (savedLocation) {
//       try {
//         const parsedLocation = JSON.parse(savedLocation);
//         setDeliveryAddress(parsedLocation.fullAddress || parsedLocation.formattedAddress || parsedLocation.address || '');
//         setFullAddressData(parsedLocation);
//       } catch (error) {
//         console.error('Error parsing delivery address:', error);
//         setDeliveryAddress('');
//       }
//     } else {
//       const savedAddress = localStorage.getItem('deliveryAddress');
//       if (savedAddress) {
//         setDeliveryAddress(savedAddress);
//       } else {
//         setDeliveryAddress('');
//       }
//     }
//   };

//   const loadUserDataFromLocalStorage = () => {
//     const savedUserData = localStorage.getItem('checkoutUserData');
//     if (savedUserData) {
//       try {
//         const parsedData = JSON.parse(savedUserData);
//         setName(parsedData.name || '');
//         setPhone(parsedData.phone || '');
//         setEmail(parsedData.email || '');
//       } catch (error) {
//         console.error('Error parsing user data from localStorage:', error);
//       }
//     }
//   };

//   const saveUserDataToLocalStorage = () => {
//     const dataToSave = { name, phone, email };
//     localStorage.setItem('checkoutUserData', JSON.stringify(dataToSave));
//     localStorage.setItem('deliveryAddress', deliveryAddress);
//   };

//   const saveUserDataToFirestore = async () => {
//     if (!userId) return;
//     try {
//       const userRef = doc(db, 'users', userId);
//       const userSnap = await getDoc(userRef);
//       if (userSnap.exists()) {
//         await updateDoc(userRef, {
//           name: name,
//           phone: phone,
//           email: email,
//           deliveryAddress: deliveryAddress,
//           updatedAt: serverTimestamp()
//         });
//       } else {
//         await setDoc(userRef, {
//           name: name,
//           phone: phone,
//           email: email,
//           deliveryAddress: deliveryAddress,
//           points: 0,
//           createdAt: serverTimestamp(),
//           updatedAt: serverTimestamp()
//         });
//       }
//     } catch (error) {
//       console.error('Error saving user data to Firestore:', error);
//     }
//   };

//   const fetchCartFromFirestore = async (uid) => {
//     try {
//       console.log("Fetching cart from Firestore");
//       const cartDocRef = doc(db, 'carts', uid);
//       const cartDoc = await getDoc(cartDocRef);
//       if (cartDoc.exists()) {
//         const cartData = cartDoc.data();
//         if (cartData.items && Object.keys(cartData.items).length > 0) {
//           const cartItemsArray = Object.values(cartData.items || {});
//           const validItems = cartItemsArray.map(item => ({
//             ...item,
//             finalPrice: item.finalPrice || item.price || item.originalPrice || 0
//           })).filter(item => item && item.id && item.name);
//           console.log("Loaded items from Firestore for checkout:", validItems);
//           setCartItems(validItems);
//         } else {
//           console.log("No items in Firestore cart, checking localStorage");
//           fetchCartFromLocalStorage();
//         }
//       } else {
//         console.log("Cart document does not exist in Firestore, checking localStorage");
//         fetchCartFromLocalStorage();
//       }
//     } catch (error) {
//       console.error('Error fetching cart from Firestore:', error);
//       fetchCartFromLocalStorage();
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchCartFromLocalStorage = () => {
//     console.log("Fetching cart from localStorage");
//     const storedCart = localStorage.getItem('cartItems');
//     console.log("Raw localStorage cart data:", storedCart);
//     if (storedCart) {
//       try {
//         const parsedCart = JSON.parse(storedCart);
//         let itemsToProcess = parsedCart;
//         if (!Array.isArray(parsedCart) && parsedCart && typeof parsedCart === 'object' && parsedCart.items) {
//           console.log("Found items property in localStorage cart object");
//           itemsToProcess = parsedCart.items;
//         }
//         if (!Array.isArray(itemsToProcess) && itemsToProcess && typeof itemsToProcess === 'object') {
//           console.log("Converting object to array from localStorage");
//           itemsToProcess = Object.values(itemsToProcess);
//         }
//         if (!Array.isArray(itemsToProcess)) {
//           console.log("itemsToProcess is not an array, setting to empty array");
//           itemsToProcess = [];
//         }
//         const validItems = itemsToProcess.map(item => ({
//           ...item,
//           finalPrice: item.finalPrice || item.price || item.originalPrice || 0
//         })).filter(item => item && item.id && item.name);
//         console.log("Valid cart items from localStorage:", validItems);
//         setCartItems(validItems);
//       } catch (error) {
//         console.error('Error parsing cart items from localStorage:', error);
//         setCartItems([]);
//       }
//     } else {
//       console.log("No cart items in localStorage");
//       setCartItems([]);
//     }
//     setLoading(false);
//   };

//   const validateForm = () => {
//     const errors = {};
//     let isValid = true;

//     if (!name.trim()) {
//       errors.name = 'Name is required';
//       isValid = false;
//     }

//     if (!phone.trim()) {
//       errors.phone = 'Phone number is required';
//       isValid = false;
//     } else if (!/^\d{10}$/.test(phone.trim())) {
//       errors.phone = 'Phone number must be 10 digits';
//       isValid = false;
//     }

//     if (!email.trim()) {
//       errors.email = 'Email is required';
//       isValid = false;
//     } else if (!/\S+@\S+\.\S+/.test(email.trim())) {
//       errors.email = 'Email is invalid';
//       isValid = false;
//     }

//     if (!deliveryAddress.trim()) {
//       errors.deliveryAddress = 'Delivery address is required';
//       isValid = false;
//     }

//     if (!paymentMethod) {
//       errors.paymentMethod = 'Please select a payment method';
//       isValid = false;
//     }

//     setFormErrors(errors);
//     setIsFormValid(isValid);
//     return isValid;
//   };

//   const getImageUrl = (image) => {
//     if (!image) return 'https://via.placeholder.com/50x50?text=Product';
//     if (typeof image === 'string' && image.startsWith('http')) return image;
//     if (typeof image === 'object' && image.hasOwnProperty('imageUrl')) return image.imageUrl;
//     return `/images/${image}`;
//   };

//   const calculatePointsEarned = () => {
//     if (!cartItems.length) {
//       setPointsEarned(0);
//       return;
//     }
//     const totalOriginalAmount = cartItems.reduce((total, item) => {
//       const originalPrice = item.originalPrice || item.price || 0;
//       const quantity = item.quantity || 1;
//       return total + (originalPrice * quantity);
//     }, 0);
//     const points = Math.floor(totalOriginalAmount / 10);
//     setPointsEarned(points);
//   };

//   const calculateSubtotal = () => {
//     return cartItems.reduce((total, item) => {
//       const itemPrice = item.finalPrice || item.price || item.originalPrice || 0;
//       const quantity = item.quantity || 1;
//       const deliverySurcharge = item.deliverySurcharge || 0;
//       return total + (itemPrice * quantity) + deliverySurcharge;
//     }, 0);
//   };

//   const calculateTotal = () => {
//     const subtotal = calculateSubtotal();
//     return subtotal + deliveryCharge;
//   };

//   const loadRazorpayScript = () => {
//     return new Promise((resolve) => {
//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   const handleRazorpayPayment = async () => {
//     const scriptLoaded = await loadRazorpayScript();
//     if (!scriptLoaded) {
//       setError('Failed to load Razorpay SDK. Please try again.');
//       return;
//     }

//     const totalAmount = calculateTotal() * 100;
//     const options = {
//       key: process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_psQiRu5RCF99Dp', // Using the correct test key
//       amount: totalAmount,
//       currency: 'INR',
//       name: 'ProCart India',
//       description: 'Order Payment',
//       handler: function (response) {
//         placeOrder(response.razorpay_payment_id);
//       },
//       prefill: { email, contact: phone, name },
//       theme: { color: '#4a90e2' },
//     };

//     const paymentObject = new window.Razorpay(options);
//     paymentObject.open();
//   };

//   const generateOrderId = () => {
//     const timestamp = new Date().getTime();
//     const randomPart = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
//     return `ORD-${timestamp}-${randomPart}`;
//   };

//   const placeOrder = async (paymentId = null) => {
//     try {
//       saveUserDataToLocalStorage();
//       if (userId) await saveUserDataToFirestore();

//       const orderId = generateOrderId();
//       const order = {
//         orderId,
//         items: cartItems,
//         totalAmount: calculateTotal(),
//         deliveryCharge,
//         deliveryDistance,
//         paymentMethod,
//         paymentId,
//         deliveryAddress,
//         customerName: name,
//         customerEmail: email,
//         customerPhone: phone,
//         pointsEarned,
//         orderDate: serverTimestamp(),
//         status: paymentMethod === 'cod' ? 'Pending Payment' : 'Processing',
//         userId: userId || 'guest',
//         createdAt: serverTimestamp(),
//         updatedAt: serverTimestamp()
//       };

//       let firestoreOrderId;
//       if (userId) {
//         const orderRef = await addDoc(collection(db, 'orders'), order);
//         firestoreOrderId = orderRef.id;
//         await setDoc(doc(db, 'users', userId, 'orders', orderRef.id), {
//           orderId: orderRef.id,
//           status: order.status,
//           totalAmount: order.totalAmount,
//           deliveryCharge: order.deliveryCharge,
//           deliveryDistance: order.deliveryDistance,
//           pointsEarned: order.pointsEarned,
//           orderDate: order.orderDate,
//           displayOrderId: orderId
//         });
//         const userRef = doc(db, 'users', userId);
//         await updateDoc(userRef, {
//           points: increment(pointsEarned),
//           updatedAt: serverTimestamp()
//         });
//       } else {
//         const orderRef = await addDoc(collection(db, 'orders'), { ...order, userId: 'guest' });
//         firestoreOrderId = orderRef.id;
//       }

//       if (userId) {
//         await setDoc(doc(db, 'carts', userId), { items: {}, updatedAt: serverTimestamp() });
//       }
//       localStorage.removeItem('cartItems');
//       window.dispatchEvent(new Event('cartUpdated'));
//       window.dispatchEvent(new Event('refreshProfile'));

//       navigate('/order-confirmation', {
//         state: {
//           paymentMethod,
//           paymentId,
//           total: calculateTotal(),
//           deliveryCharge,
//           deliveryDistance,
//           pointsEarned,
//           orderId,
//           firestoreOrderId,
//           customerName: name,
//           customerPhone: phone,
//           deliveryAddress
//         },
//       });
//     } catch (error) {
//       console.error('Error placing order:', error);
//       setError('Failed to place your order. Please try again.');
//     }
//   };

//   const handleCheckout = (e) => {
//     e.preventDefault();
//     setError('');

//     if (!validateForm()) {
//       setError('Please fill in all required fields correctly before placing your order.');
//       return;
//     }

//     if (cartItems.length === 0) {
//       setError('Your cart is empty.');
//       return;
//     }

//     if (paymentMethod === 'razorpay') {
//       handleRazorpayPayment();
//     } else if (paymentMethod === 'cod') {
//       placeOrder();
//     }
//   };

//   const forceReloadCart = () => {
//     fetchCartFromLocalStorage();
//   };

//   const handleGoBack = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     navigate(-2, { replace: true });
//   };

//   const getDeliveryTitle = (speed) => {
//     switch (speed) {
//       case 'quick':
//         return 'Quick Delivery';
//       case 'express':
//         return 'Express Delivery';
//       case 'late':
//         return 'Eco Delivery';
//       case 'normal':
//       default:
//         return 'Standard Delivery';
//     }
//   };

//   const getDeliveryDisplayText = () => {
//     const subtotal = calculateSubtotal();

//     if (subtotal >= FREE_DELIVERY_THRESHOLD) {
//       return 'FREE';
//     }

//     if (isCalculatingDelivery) {
//       return 'Calculating...';
//     }

//     if (deliveryDistance > 0) {
//       return `${deliveryDistance.toFixed(1)} km × ₹${DELIVERY_RATE_PER_KM}`;
//     }

//     return 'Estimated';
//   };

//   // Function to copy address to clipboard

//   if (loading) {
//     return (
//       <div className="checkout-loading">
//         <p>Loading your order details...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="checkout-container" style={{ minHeight: '100vh', padding: '20px', display: 'flex', flexDirection: 'column' }}>
//       <button className="go-back-btn2" onClick={handleGoBack}>
//         ← Go Back
//       </button>
//       <h2 className="checkout-title">Checkout</h2>
//       {error && <div className="checkout-error">{error}</div>}
//       <div className="checkout-content" style={{ flex: '1', display: 'flex', gap: '20px', maxHeight: 'calc(100vh + 600px)', overflow: 'hidden' }}>
//         <div className="checkout-summary" style={{ flex: '1', maxHeight: '100%', padding: '15px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '5px' }}>
//           <h3>Order Summary</h3>
//           {cartItems.length === 0 ? (
//             <div className="empty-cart-section">
//               <p>Your cart is empty.</p>
//               <button className="reload-cart-btn" onClick={forceReloadCart}>
//                 Reload Cart Items
//               </button>
//               <div className="debug-info">
//                 <p>Debug Info:</p>
//                 <p>localStorage cartItems: {localStorage.getItem('cartItems') ? 'Found' : 'Not found'}</p>
//                 <p>userId: {userId || 'Not logged in'}</p>
//               </div>
//             </div>
//           ) : (
//             <div className="checkout-items" style={{ maxHeight: 'calc(100% - 100px)' }}>
//               {cartItems.map((item) => (
//                 <div key={item.id} className="checkout-item" style={{ marginBottom: '15px', padding: '10px', border: '1px solid #eee', borderRadius: '5px', display: 'flex', alignItems: 'center' }}>
//                   <img
//                     src={getImageUrl(item.imageUrl || item.image)}
//                     alt={item.name}
//                     className="checkout-item-image"
//                     style={{ width: '50px', height: '50px', marginRight: '10px' }}
//                     onError={(e) => {
//                       console.error("Image failed to load:", item.imageUrl || item.image);
//                       e.target.src = 'https://via.placeholder.com/50x50?text=Product';
//                     }}
//                   />
//                   <div className="checkout-item-details">
//                     <h4>{item.name}</h4>
//                     <p>
//                       ₹{(item.finalPrice || item.price || 0).toLocaleString('en-IN')} x {item.quantity || 1} = ₹
//                       {((item.finalPrice || item.price || 0) * (item.quantity || 1)).toLocaleString('en-IN')}
//                     </p>
//                     {item.deliverySurcharge && (
//                       <p className="delivery-surcharge">
//                         + Delivery Surcharge: ₹{item.deliverySurcharge.toLocaleString('en-IN')}
//                       </p>
//                     )}
//                     {item.deliverySpeed && (
//                       <div className="item-delivery-info">
//                         <span className={`delivery-badge ${item.deliverySpeed}`}>
//                           {getDeliveryTitle(item.deliverySpeed)}
//                         </span>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               ))}
//               <div className="checkout-total">
//                 <div className="summary-row">
//                   <span>Subtotal:</span>
//                   <span>₹{calculateSubtotal().toLocaleString('en-IN')}</span>
//                 </div>
//                 <div className="summary-row delivery-charge" style={{
//                   color: deliveryCharge === 0 ? 'green' : 'red',
//                   fontSize: '14px'
//                 }}>
//                   <span>
//                     Delivery Fee ({getDeliveryDisplayText()})
//                     {isCalculatingDelivery && <span className="calculating-spinner"> 🔄</span>}
//                   </span>
//                   <span>
//                     {deliveryCharge === 0 ? 'FREE' : `+₹${deliveryCharge.toLocaleString('en-IN')}`}
//                   </span>
//                 </div>
//                 {deliveryError && (
//                   <div className="delivery-error" style={{ fontSize: '12px', color: 'orange', marginTop: '5px' }}>
//                     {deliveryError}
//                   </div>
//                 )}

//                 <hr style={{ border: '1px dashed #ccc', margin: '10px 0' }} />
//                 <div className="summary-row total">
//                   <h4>Total:</h4>
//                   <span>₹{calculateTotal().toLocaleString('en-IN')}</span>
//                 </div>
//                 {pointsEarned > 0 && (
//                   <div className="summary-row points" style={{ color: 'green' }}>
//                     <span>Points Earned:</span>
//                     <span>{pointsEarned} points</span>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>

//         <div className="checkout-form" style={{ flex: '1', maxHeight: '100%', padding: '15px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '5px' }}>
//           <h3>Delivery Information</h3>
//           <form onSubmit={handleCheckout} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//             <div className="form-group">
//               <label htmlFor="name">Full Name *</label>
//               <input
//                 type="text"
//                 id="name"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//                 className={formErrors.name ? 'input-error' : ''}
//                 placeholder="Enter your full name"
//               />
//               {formErrors.name && <div className="error-message">{formErrors.name}</div>}
//             </div>

//             <div className="form-group">
//               <label htmlFor="phone">Phone Number *</label>
//               <input
//                 type="tel"
//                 id="phone"
//                 value={phone}
//                 onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
//                 className={formErrors.phone ? 'input-error' : ''}
//                 placeholder="10-digit mobile number"
//                 maxLength="10"
//               />
//               {formErrors.phone && <div className="error-message">{formErrors.phone}</div>}
//             </div>

//             <div className="form-group">
//               <label htmlFor="email">Email Address *</label>
//               <input
//                 type="email"
//                 id="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 className={formErrors.email ? 'input-error' : ''}
//                 placeholder="Enter your email address"
//               />
//               {formErrors.email && <div className="error-message">{formErrors.email}</div>}
//             </div>

//             <div className="form-group">
//               <label htmlFor="deliveryAddress">Delivery Address *</label>
//               <div className="address-input-container" style={{ position: 'relative' }}>
//                 <textarea
//                   id="deliveryAddress"
//                   value={deliveryAddress}
//                   onChange={(e) => setDeliveryAddress(e.target.value)}
//                   className={formErrors.deliveryAddress ? 'input-error' : ''}
//                   placeholder="Enter your complete delivery address (include area, landmark, city)"
//                   rows="3"
//                 />
//                 <div className="address-actions" style={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   marginTop: '8px',
//                   gap: '10px'
//                 }}>
//                   <button
//                     type="button"
//                     className="use-current-location-btn"
//                     onClick={handleUseCurrentLocation}
//                     disabled={isLocating}
//                     style={{
//                       flex: 1,
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       padding: '8px 12px',
//                       backgroundColor: '#f5f5f5',
//                       border: '1px solid #ddd',
//                       borderRadius: '4px',
//                       cursor: isLocating ? 'wait' : 'pointer',
//                       fontSize: '14px',
//                       color: '#333'
//                     }}
//                   >
//                     {isLocating ? (
//                       <>
//                         <span className="location-spinner" style={{
//                           display: 'inline-block',
//                           width: '16px',
//                           height: '16px',
//                           border: '2px solid rgba(0, 0, 0, 0.1)',
//                           borderTopColor: '#333',
//                           borderRadius: '50%',
//                           animation: 'spin 0.8s linear infinite',
//                           marginRight: '8px'
//                         }}></span>
//                         Detecting...
//                       </>
//                     ) : (
//                       <>
//                         <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '8px' }}>
//                           <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" />
//                         </svg>
//                         Use My Location
//                       </>
//                     )}
//                   </button>


//                 </div>
//               </div>
//               {locationError && (
//                 <div className="location-error" style={{
//                   color: '#e53935',
//                   fontSize: '13px',
//                   marginTop: '5px',
//                   padding: '5px',
//                   backgroundColor: 'rgba(229, 57, 53, 0.1)',
//                   borderRadius: '4px'
//                 }}>
//                   {locationError}
//                 </div>
//               )}
//               {formErrors.deliveryAddress && <div className="error-message">{formErrors.deliveryAddress}</div>}
//               <div className="address-helper" style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
//                 💡 Tip: Include your area name, nearby landmark, and city for accurate delivery charges
//               </div>
//             </div>

//             <h3 className="section-title">Payment Method</h3>
//             <div className="payment-options">
      
//               <div
//                 className={`payment-option ${paymentMethod === 'razorpay' ? 'selected' : ''}`}
//                 onClick={() => setPaymentMethod('razorpay')}
//               >
//                 <div className="radio-container">
//                   <input
//                     type="radio"
//                     id="razorpay"
//                     name="paymentMethod"
//                     value="razorpay"
//                     checked={paymentMethod === 'razorpay'}
//                     onChange={(e) => setPaymentMethod(e.target.value)}
//                     className="radio-input"
//                   />
//                   <span className="radio-checkmark"></span>
//                 </div>
//                 <label htmlFor="razorpay" className="payment-label">Pay with Razorpay</label>
//               </div>
//             </div>
//             {formErrors.paymentMethod && <div className="error-message">{formErrors.paymentMethod}</div>}

//             <button
//               type="submit"
//               className="place-order-btn"
//               disabled={cartItems.length === 0 || !isFormValid || isCalculatingDelivery}
//               style={{
//                 padding: '10px 20px',
//                 width: '100%',
//                 marginTop: '15px',
//                 opacity: (cartItems.length === 0 || !isFormValid || isCalculatingDelivery) ? 0.6 : 1,
//                 cursor: (cartItems.length === 0 || !isFormValid || isCalculatingDelivery) ? 'not-allowed' : 'pointer'
//               }}
//             >
//               {isCalculatingDelivery ? 'Calculating Delivery...' : 'Place Order'}
//             </button>
//           </form>
//         </div>
//       </div>

//       {/* Add custom animation for location spinner */}
//       <style dangerouslySetInnerHTML={{
//         __html: `
//         @keyframes spin {
//           to {
//             transform: rotate(360deg);
//           }
//         }
        
//         .use-current-location-btn:hover {
//           background-color: #e9e9e9 !important;
//         }
        
//         .copy-address-btn:hover {
//           background-color: #e9e9e9 !important;
//         }
        
//         .location-spinner {
//           animation: spin 0.8s linear infinite;
//         }
        
//         .calculating-spinner {
//           display: inline-block;
//           animation: spin 1s linear infinite;
//         }
//       `}} />
//     </div>
//   );
// };

// export default Checkout;





























// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   doc,
//   getDoc,
//   setDoc,
//   updateDoc,
//   collection,
//   addDoc,
//   serverTimestamp,
//   increment
// } from 'firebase/firestore';
// import { db, auth } from '../../firebase/firebaseConfig';
// import { onAuthStateChanged } from 'firebase/auth';
// import './Checkout.css';

// // Google Maps API key - using the same one from the Header component
// const GOOGLE_MAPS_API_KEY = 'AIzaSyA5ReIwel6soo1uIWWRvAIdIubZQKnbjfc';

// const Checkout = () => {
//   const [cartItems, setCartItems] = useState([]);
//   const [paymentMethod, setPaymentMethod] = useState('razorpay');
//   const [deliveryAddress, setDeliveryAddress] = useState('');
//   const [name, setName] = useState('');
//   const [phone, setPhone] = useState('');
//   const [email, setEmail] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [userId, setUserId] = useState(null);
//   const [userData, setUserData] = useState({});
//   const [formErrors, setFormErrors] = useState({});
//   const [isFormValid, setIsFormValid] = useState(false);
//   const navigate = useNavigate();
//   const [deliveryCharge, setDeliveryCharge] = useState(0);
//   const [pointsEarned, setPointsEarned] = useState(0);
//   const [deliveryDistance, setDeliveryDistance] = useState(0);
//   const [isCalculatingDelivery, setIsCalculatingDelivery] = useState(false);
//   const [deliveryError, setDeliveryError] = useState('');
  
//   // For coupon and points
//   const [couponApplied, setCouponApplied] = useState(false);
//   const [couponDiscount, setCouponDiscount] = useState(0);
//   const [pointsUsed, setPointsUsed] = useState(0);
//   const [pointsDiscount, setPointsDiscount] = useState(0);

//   // New state variables for location fetching
//   const [isLocating, setIsLocating] = useState(false);
//   const [locationError, setLocationError] = useState('');
//   const [fullAddressData, setFullAddressData] = useState(null);

//   const INVENTORY_LOCATION = "SP Road, Bangalore North, Bangalore, Karnataka 560002, India";
//   const DELIVERY_RATE_PER_KM = 45;
//   const BASE_DELIVERY_CHARGE = 50; // Minimum delivery charge
//   const MAX_DELIVERY_CHARGE = 500; // Maximum delivery charge
//   const FREE_DELIVERY_THRESHOLD = 2000; // Free delivery above this amount

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         setUserId(user.uid);
//         fetchUserData(user.uid);
//         fetchCartFromFirestore(user.uid);
//       } else {
//         setUserId(null);
//         fetchCartFromLocalStorage();
//         loadUserDataFromLocalStorage();
//       }
//     });
//     return () => unsubscribe();
//   }, []);

//   useEffect(() => {
//     const handleCartUpdate = () => {
//       console.log("Cart update detected in Checkout");
//       if (userId) {
//         fetchCartFromFirestore(userId);
//       } else {
//         fetchCartFromLocalStorage();
//       }
//     };
//     window.addEventListener('cartUpdated', handleCartUpdate);
//     return () => window.removeEventListener('cartUpdated', handleCartUpdate);
//   }, [userId]);

//   useEffect(() => {
//     validateForm();
//     calculatePointsEarned();
    
//     // Check coupon and points from cart items
//     if (cartItems.length > 0) {
//       // Check if any items have coupon applied
//       const anyCouponApplied = cartItems.some(item => item.couponApplied);
//       setCouponApplied(anyCouponApplied);
      
//       // Calculate coupon discount
//       if (anyCouponApplied) {
//         const subtotal = calculateSubtotal();
//         const discount = subtotal * 0.02; // 2% discount
//         setCouponDiscount(discount);
//       } else {
//         setCouponDiscount(0);
//       }
      
//       // Check for points used - IMPORTANT: use exact points from cart
//       const totalPointsUsed = cartItems.reduce((total, item) => {
//         return total + (item.pointsUsed || 0);
//       }, 0);
      
//       if (totalPointsUsed > 0) {
//         setPointsUsed(totalPointsUsed);
        
//         // Use exact points discount from cart (100 points = ₹1)
//         const discount = totalPointsUsed / 100;
//         setPointsDiscount(discount);
//         console.log(`Using ${totalPointsUsed} points for ₹${discount.toFixed(2)} discount from cart`);
//       } else {
//         setPointsUsed(0);
//         setPointsDiscount(0);
//       }
//     }
//   }, [name, phone, email, deliveryAddress, paymentMethod, cartItems]);

//   // Get detailed address from coordinates
//   const getDetailedAddressFromCoordinates = async (latitude, longitude) => {
//     try {
//       const response = await fetch(
//         `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_MAPS_API_KEY}`
//       );

//       if (!response.ok) {
//         throw new Error('Google Geocoding API error');
//       }

//       const data = await response.json();

//       if (data.status !== 'OK' || !data.results || data.results.length === 0) {
//         throw new Error('No address found for this location');
//       }

//       const fullResult = data.results[0];
//       const formattedAddress = fullResult.formatted_address;

//       // For a more concise display address in UI if needed
//       const displayAddress = formattedAddress.split(',').slice(0, 3).join(',');

//       return {
//         fullAddress: formattedAddress,
//         formattedAddress: formattedAddress, // Using full address for delivery
//         latitude,
//         longitude
//       };
//     } catch (googleError) {
//       console.error("Error with Google Geocoding:", googleError);
//       try {
//         // Fallback to another geocoding service
//         const response = await fetch(
//           `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
//         );

//         if (!response.ok) {
//           throw new Error('Geocoding API error');
//         }

//         const data = await response.json();
//         const locality = data.locality || '';
//         const district = data.localityInfo?.administrative?.find(a => a.adminLevel === 6)?.name || '';
//         const subDistrict = data.localityInfo?.administrative?.find(a => a.adminLevel === 8)?.name || '';
//         const road = data.road || '';
//         const street = data.street || '';
//         const city = data.city || data.locality || 'Bengaluru';
//         const state = data.principalSubdivision || 'Karnataka';
//         const country = data.countryName || 'India';
//         const postalCode = data.postcode || '';

//         // Construct a more complete address from the components
//         const addressComponents = [
//           road || street,
//           locality,
//           subDistrict,
//           district,
//           city,
//           state,
//           country,
//           postalCode
//         ].filter(Boolean);

//         const formattedAddress = addressComponents.join(', ');

//         return {
//           fullAddress: formattedAddress,
//           formattedAddress: formattedAddress,
//           latitude,
//           longitude,
//           city,
//           state
//         };
//       } catch (fallbackError) {
//         console.error("Error in fallback geocoding:", fallbackError);
//         throw new Error('Could not determine your location. Please try again or enter your address manually.');
//       }
//     }
//   };

//   // Handle using current location
//   const handleUseCurrentLocation = () => {
//     if (navigator.geolocation) {
//       setIsLocating(true);
//       setLocationError('');

//       navigator.geolocation.getCurrentPosition(
//         async (position) => {
//           try {
//             const { latitude, longitude } = position.coords;
//             const addressData = await getDetailedAddressFromCoordinates(latitude, longitude);

//             // Set address in form
//             setDeliveryAddress(addressData.fullAddress);
//             setFullAddressData(addressData);

//             // Store in localStorage for future use
//             try {
//               localStorage.setItem('userLocation', JSON.stringify(addressData));
//             } catch (error) {
//               console.error("Error saving to localStorage:", error);
//             }

//             setIsLocating(false);
//           } catch (error) {
//             console.error("Error getting detailed address:", error);
//             setLocationError(error.message);
//             setIsLocating(false);
//           }
//         },
//         (error) => {
//           console.error("Geolocation error:", error);
//           let errorMessage = 'Unable to detect location';

//           if (error.code === 1) {
//             errorMessage = 'Location access denied. Please enable location services.';
//           } else if (error.code === 2) {
//             errorMessage = 'Location unavailable. Please try again later.';
//           } else if (error.code === 3) {
//             errorMessage = 'Location request timed out. Please try again.';
//           }

//           setLocationError(errorMessage);
//           setIsLocating(false);
//         },
//         {
//           enableHighAccuracy: true,
//           timeout: 10000,
//           maximumAge: 0
//         }
//       );
//     } else {
//       setLocationError('Geolocation is not supported by your browser');
//     }
//   };

//   // Debounced delivery calculation
//   const calculateDeliveryCharges = useCallback(
//     debounce(async (address) => {
//       if (!address || !address.trim()) {
//         setDeliveryDistance(0);
//         setDeliveryCharge(0);
//         setDeliveryError('');
//         return;
//       }

//       setIsCalculatingDelivery(true);
//       setDeliveryError('');

//       try {
//         // First, try to calculate using a more reliable method
//         const distance = await calculateDistanceUsingGeocoding(address);

//         if (distance > 0) {
//           const calculatedCharge = calculateDeliveryFee(distance);
//           setDeliveryDistance(distance);
//           setDeliveryCharge(calculatedCharge);
//           console.log(`Distance: ${distance.toFixed(1)} km, Charge: ₹${calculatedCharge}`);
//         } else {
//           // Fallback to estimated charges based on location patterns
//           const estimatedCharge = estimateDeliveryCharge(address);
//           setDeliveryDistance(0);
//           setDeliveryCharge(estimatedCharge);

//         }
//       } catch (error) {
//         console.error('Error calculating delivery charges:', error);
//         const estimatedCharge = estimateDeliveryCharge(address);
//         setDeliveryDistance(0);
//         setDeliveryCharge(estimatedCharge);
//         setDeliveryError('Using estimated delivery charges due to calculation error.');
//       } finally {
//         setIsCalculatingDelivery(false);
//       }
//     }, 1000),
//     []
//   );

//   useEffect(() => {
//     if (deliveryAddress) {
//       calculateDeliveryCharges(deliveryAddress);
//     }
//   }, [deliveryAddress, calculateDeliveryCharges]);

//   // Debounce function
//   function debounce(func, wait) {
//     let timeout;
//     return function executedFunction(...args) {
//       const later = () => {
//         clearTimeout(timeout);
//         func(...args);
//       };
//       clearTimeout(timeout);
//       timeout = setTimeout(later, wait);
//     };
//   }

//   // More reliable distance calculation using geocoding
//   const calculateDistanceUsingGeocoding = async (address) => {
//     try {
//       // Use a geocoding service to get coordinates
//       const response = await fetch(
//         `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(address)}&key=YOUR_OPENCAGE_API_KEY&countrycode=IN&limit=1`
//       );

//       if (!response.ok) {
//         throw new Error('Geocoding service unavailable');
//       }

//       const data = await response.json();

//       if (data.results && data.results.length > 0) {
//         const { lat, lng } = data.results[0].geometry;

//         // SP Road coordinates (approximate)
//         const spRoadLat = 13.0067;
//         const spRoadLng = 77.5667;

//         const distance = calculateHaversineDistance(spRoadLat, spRoadLng, lat, lng);
//         return distance;
//       }

//       return 0;
//     } catch (error) {
//       console.error('Error in geocoding:', error);
//       return 0;
//     }
//   };

//   // Haversine formula for distance calculation
//   const calculateHaversineDistance = (lat1, lon1, lat2, lon2) => {
//     const R = 6371; // Radius of the Earth in kilometers
//     const dLat = (lat2 - lat1) * Math.PI / 180;
//     const dLon = (lon2 - lon1) * Math.PI / 180;
//     const a =
//       Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//       Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
//       Math.sin(dLon / 2) * Math.sin(dLon / 2);
//     const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//     const distance = R * c;
//     return distance;
//   };

//   // Calculate delivery fee based on distance
//   const calculateDeliveryFee = (distance) => {
//     const subtotal = calculateSubtotal();

//     // Free delivery for orders above threshold
//     if (subtotal >= FREE_DELIVERY_THRESHOLD) {
//       return 0;
//     }

//     let charge = Math.max(BASE_DELIVERY_CHARGE, Math.ceil(distance * DELIVERY_RATE_PER_KM));
//     return Math.min(charge, MAX_DELIVERY_CHARGE);
//   };

//   // Estimate delivery charge based on location patterns
//   const estimateDeliveryCharge = (address) => {
//     const subtotal = calculateSubtotal();

//     // Free delivery for orders above threshold
//     if (subtotal >= FREE_DELIVERY_THRESHOLD) {
//       return 0;
//     }

//     const lowerAddress = address.toLowerCase();

//     // Bangalore city center areas (closer to SP Road)
//     if (lowerAddress.includes('mg road') ||
//       lowerAddress.includes('brigade road') ||
//       lowerAddress.includes('commercial street') ||
//       lowerAddress.includes('chickpet') ||
//       lowerAddress.includes('gandhi nagar') ||
//       lowerAddress.includes('rajajinagar') ||
//       lowerAddress.includes('basavanagudi') ||
//       lowerAddress.includes('malleshwaram')) {
//       return 80;
//     }

//     // Nearby areas
//     if (lowerAddress.includes('koramangala') ||
//       lowerAddress.includes('indiranagar') ||
//       lowerAddress.includes('whitefield') ||
//       lowerAddress.includes('hsr layout') ||
//       lowerAddress.includes('btm layout') ||
//       lowerAddress.includes('jp nagar') ||
//       lowerAddress.includes('banashankari') ||
//       lowerAddress.includes('vijayanagar')) {
//       return 120;
//     }

//     // Outer Bangalore areas
//     if (lowerAddress.includes('electronic city') ||
//       lowerAddress.includes('sarjapur') ||
//       lowerAddress.includes('marathahalli') ||
//       lowerAddress.includes('hebbal') ||
//       lowerAddress.includes('yelahanka') ||
//       lowerAddress.includes('bommanahalli') ||
//       lowerAddress.includes('bannerghatta') ||
//       lowerAddress.includes('kengeri')) {
//       return 180;
//     }

//     // Default charge for other Bangalore areas
//     if (lowerAddress.includes('bangalore') ||
//       lowerAddress.includes('bengaluru') ||
//       lowerAddress.includes('karnataka')) {
//       return 150;
//     }

//     // Outside Bangalore
//     return 250;
//   };

//   const fetchUserData = async (uid) => {
//     try {
//       const userRef = doc(db, 'users', uid);
//       const userSnap = await getDoc(userRef);
//       if (userSnap.exists()) {
//         const data = userSnap.data();
//         setUserData(data);
//         setName(data.name || '');
//         setPhone(data.phone || '');
//         setEmail(data.email || '');
//         if (data.deliveryAddress) {
//           setDeliveryAddress(data.deliveryAddress);
//         } else {
//           loadDeliveryAddress();
//         }
//       } else {
//         console.log("No user data found");
//         loadDeliveryAddress();
//         loadUserDataFromLocalStorage();
//       }
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//       loadDeliveryAddress();
//       loadUserDataFromLocalStorage();
//     }
//   };

//   const loadDeliveryAddress = () => {
//     const savedLocation = localStorage.getItem('userLocation');
//     if (savedLocation) {
//       try {
//         const parsedLocation = JSON.parse(savedLocation);
//         setDeliveryAddress(parsedLocation.fullAddress || parsedLocation.formattedAddress || parsedLocation.address || '');
//         setFullAddressData(parsedLocation);
//       } catch (error) {
//         console.error('Error parsing delivery address:', error);
//         setDeliveryAddress('');
//       }
//     } else {
//       const savedAddress = localStorage.getItem('deliveryAddress');
//       if (savedAddress) {
//         setDeliveryAddress(savedAddress);
//       } else {
//         setDeliveryAddress('');
//       }
//     }
//   };

//   const loadUserDataFromLocalStorage = () => {
//     const savedUserData = localStorage.getItem('checkoutUserData');
//     if (savedUserData) {
//       try {
//         const parsedData = JSON.parse(savedUserData);
//         setName(parsedData.name || '');
//         setPhone(parsedData.phone || '');
//         setEmail(parsedData.email || '');
//       } catch (error) {
//         console.error('Error parsing user data from localStorage:', error);
//       }
//     }
//   };

//   const saveUserDataToLocalStorage = () => {
//     const dataToSave = { name, phone, email };
//     localStorage.setItem('checkoutUserData', JSON.stringify(dataToSave));
//     localStorage.setItem('deliveryAddress', deliveryAddress);
//   };

//   const saveUserDataToFirestore = async () => {
//     if (!userId) return;
//     try {
//       const userRef = doc(db, 'users', userId);
//       const userSnap = await getDoc(userRef);
//       if (userSnap.exists()) {
//         await updateDoc(userRef, {
//           name: name,
//           phone: phone,
//           email: email,
//           deliveryAddress: deliveryAddress,
//           updatedAt: serverTimestamp()
//         });
//       } else {
//         await setDoc(userRef, {
//           name: name,
//           phone: phone,
//           email: email,
//           deliveryAddress: deliveryAddress,
//           points: 0,
//           createdAt: serverTimestamp(),
//           updatedAt: serverTimestamp()
//         });
//       }
//     } catch (error) {
//       console.error('Error saving user data to Firestore:', error);
//     }
//   };

//   const fetchCartFromFirestore = async (uid) => {
//     try {
//       console.log("Fetching cart from Firestore");
//       const cartDocRef = doc(db, 'carts', uid);
//       const cartDoc = await getDoc(cartDocRef);
//       if (cartDoc.exists()) {
//         const cartData = cartDoc.data();
//         if (cartData.items && Object.keys(cartData.items).length > 0) {
//           const cartItemsArray = Object.values(cartData.items || {});
//           const validItems = cartItemsArray.map(item => ({
//             ...item,
//             finalPrice: item.finalPrice || item.price || item.originalPrice || 0,
//             pointsUsed: item.pointsUsed || 0,
//             pointsDiscount: item.pointsDiscount || 0,
//             couponApplied: item.couponApplied || false
//           })).filter(item => item && item.id && item.name);
          
//           console.log("Loaded items from Firestore for checkout:", validItems);
          
//           // Calculate total points used and discount
//           const totalPointsUsed = validItems.reduce((total, item) => total + (item.pointsUsed || 0), 0);
//           const pointsDiscount = totalPointsUsed / 100;
//           setPointsUsed(totalPointsUsed);
//           setPointsDiscount(pointsDiscount);
          
//           // Check if coupon is applied
//           const couponApplied = validItems.some(item => item.couponApplied);
//           setCouponApplied(couponApplied);
//           if (couponApplied) {
//             const subtotal = validItems.reduce((total, item) => 
//               total + (item.price * (item.quantity || 1)), 0);
//             setCouponDiscount(subtotal * 0.02); // 2% discount
//           }
          
//           setCartItems(validItems);
//         } else {
//           console.log("No items in Firestore cart, checking localStorage");
//           fetchCartFromLocalStorage();
//         }
//       } else {
//         console.log("Cart document does not exist in Firestore, checking localStorage");
//         fetchCartFromLocalStorage();
//       }
//     } catch (error) {
//       console.error('Error fetching cart from Firestore:', error);
//       fetchCartFromLocalStorage();
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchCartFromLocalStorage = () => {
//     console.log("Fetching cart from localStorage");
//     const storedCart = localStorage.getItem('cartItems');
//     console.log("Raw localStorage cart data:", storedCart);
//     if (storedCart) {
//       try {
//         const parsedCart = JSON.parse(storedCart);
//         let itemsToProcess = parsedCart;
//         if (!Array.isArray(parsedCart) && parsedCart && typeof parsedCart === 'object' && parsedCart.items) {
//           console.log("Found items property in localStorage cart object");
//           itemsToProcess = parsedCart.items;
//         }
//         if (!Array.isArray(itemsToProcess) && itemsToProcess && typeof itemsToProcess === 'object') {
//           console.log("Converting object to array from localStorage");
//           itemsToProcess = Object.values(itemsToProcess);
//         }
//         if (!Array.isArray(itemsToProcess)) {
//           console.log("itemsToProcess is not an array, setting to empty array");
//           itemsToProcess = [];
//         }
//         const validItems = itemsToProcess.map(item => ({
//           ...item,
//           finalPrice: item.finalPrice || item.price || item.originalPrice || 0,
//           pointsUsed: item.pointsUsed || 0,
//           pointsDiscount: item.pointsDiscount || 0,
//           couponApplied: item.couponApplied || false
//         })).filter(item => item && item.id && item.name);
        
//         console.log("Valid cart items from localStorage:", validItems);
        
//         // Calculate total points used and discount
//         const totalPointsUsed = validItems.reduce((total, item) => total + (item.pointsUsed || 0), 0);
//         const pointsDiscount = totalPointsUsed / 100;
//         setPointsUsed(totalPointsUsed);
//         setPointsDiscount(pointsDiscount);
        
//         // Check if coupon is applied
//         const couponApplied = validItems.some(item => item.couponApplied);
//         setCouponApplied(couponApplied);
//         if (couponApplied) {
//           const subtotal = validItems.reduce((total, item) => 
//             total + (item.price * (item.quantity || 1)), 0);
//           setCouponDiscount(subtotal * 0.02); // 2% discount
//         }
        
//         setCartItems(validItems);
//       } catch (error) {
//         console.error('Error parsing cart items from localStorage:', error);
//         setCartItems([]);
//       }
//     } else {
//       console.log("No cart items in localStorage");
//       setCartItems([]);
//     }
//     setLoading(false);
//   };

//   const validateForm = () => {
//     const errors = {};
//     let isValid = true;

//     if (!name.trim()) {
//       errors.name = 'Name is required';
//       isValid = false;
//     }

//     if (!phone.trim()) {
//       errors.phone = 'Phone number is required';
//       isValid = false;
//     } else if (!/^\d{10}$/.test(phone.trim())) {
//       errors.phone = 'Phone number must be 10 digits';
//       isValid = false;
//     }

//     if (!email.trim()) {
//       errors.email = 'Email is required';
//       isValid = false;
//     } else if (!/\S+@\S+\.\S+/.test(email.trim())) {
//       errors.email = 'Email is invalid';
//       isValid = false;
//     }

//     if (!deliveryAddress.trim()) {
//       errors.deliveryAddress = 'Delivery address is required';
//       isValid = false;
//     }

//     if (!paymentMethod) {
//       errors.paymentMethod = 'Please select a payment method';
//       isValid = false;
//     }

//     setFormErrors(errors);
//     setIsFormValid(isValid);
//     return isValid;
//   };

//   const getImageUrl = (image) => {
//     if (!image) return 'https://via.placeholder.com/50x50?text=Product';
//     if (typeof image === 'string' && image.startsWith('http')) return image;
//     if (typeof image === 'object' && image.hasOwnProperty('imageUrl')) return image.imageUrl;
//     return `/images/${image}`;
//   };

//   const calculatePointsEarned = () => {
//     if (!cartItems.length) {
//       setPointsEarned(0);
//       return;
//     }
//     const totalOriginalAmount = cartItems.reduce((total, item) => {
//       const originalPrice = item.originalPrice || item.price || 0;
//       const quantity = item.quantity || 1;
//       return total + (originalPrice * quantity);
//     }, 0);
//     const points = Math.floor(totalOriginalAmount / 10);
//     setPointsEarned(points);
//   };

//   const calculateSubtotal = () => {
//     return cartItems.reduce((total, item) => {
//       const itemPrice = item.finalPrice || item.price || item.originalPrice || 0;
//       const quantity = item.quantity || 1;
//       const deliverySurcharge = item.deliverySurcharge || 0;
//       return total + (itemPrice * quantity) + deliverySurcharge;
//     }, 0);
//   };

//   const calculateTotal = () => {
//     const subtotal = calculateSubtotal();
//     // Include coupon and points discounts in total calculation
//     return subtotal + deliveryCharge - couponDiscount - pointsDiscount;
//   };

//   const loadRazorpayScript = () => {
//     return new Promise((resolve) => {
//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   const handleRazorpayPayment = async () => {
//     const scriptLoaded = await loadRazorpayScript();
//     if (!scriptLoaded) {
//       setError('Failed to load Razorpay SDK. Please try again.');
//       return;
//     }

//     const totalAmount = calculateTotal() * 100;
//     const options = {
//       key: process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_psQiRu5RCF99Dp', // Using the correct test key
//       amount: totalAmount,
//       currency: 'INR',
//       name: 'ProCart India',
//       description: 'Order Payment',
//       handler: function (response) {
//         placeOrder(response.razorpay_payment_id);
//       },
//       prefill: { email, contact: phone, name },
//       theme: { color: '#4a90e2' },
//     };

//     const paymentObject = new window.Razorpay(options);
//     paymentObject.open();
//   };

//   const generateOrderId = () => {
//     const timestamp = new Date().getTime();
//     const randomPart = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
//     return `ORD-${timestamp}-${randomPart}`;
//   };

//   const placeOrder = async (paymentId = null) => {
//     try {
//       saveUserDataToLocalStorage();
//       if (userId) await saveUserDataToFirestore();

//       const orderId = generateOrderId();
//       const order = {
//         orderId,
//         items: cartItems,
//         subtotal: calculateSubtotal(),
//         couponApplied: couponApplied,
//         couponDiscount: couponDiscount,
//         pointsUsed: pointsUsed,
//         pointsDiscount: pointsDiscount,
//         deliveryCharge,
//         deliveryDistance,
//         totalAmount: calculateTotal(),
//         paymentMethod,
//         paymentId,
//         deliveryAddress,
//         customerName: name,
//         customerEmail: email,
//         customerPhone: phone,
//         pointsEarned,
//         orderDate: serverTimestamp(),
//         status: paymentMethod === 'cod' ? 'Pending Payment' : 'Processing',
//         userId: userId || 'guest',
//         createdAt: serverTimestamp(),
//         updatedAt: serverTimestamp()
//       };

//       let firestoreOrderId;
//       if (userId) {
//         const orderRef = await addDoc(collection(db, 'orders'), order);
//         firestoreOrderId = orderRef.id;
//         await setDoc(doc(db, 'users', userId, 'orders', orderRef.id), {
//           orderId: orderRef.id,
//           status: order.status,
//           totalAmount: order.totalAmount,
//           deliveryCharge: order.deliveryCharge,
//           deliveryDistance: order.deliveryDistance,
//           pointsEarned: order.pointsEarned,
//           orderDate: order.orderDate,
//           displayOrderId: orderId
//         });
        
//         // Update user points (deduct used points and add earned points)
//         const userRef = doc(db, 'users', userId);
//         if (pointsUsed > 0) {
//           // If points were used, deduct them and add new points
//           await updateDoc(userRef, {
//             points: increment(pointsEarned - pointsUsed),
//             updatedAt: serverTimestamp()
//           });
//         } else {
//           // Otherwise just add earned points
//           await updateDoc(userRef, {
//             points: increment(pointsEarned),
//             updatedAt: serverTimestamp()
//           });
//         }
//       } else {
//         const orderRef = await addDoc(collection(db, 'orders'), { ...order, userId: 'guest' });
//         firestoreOrderId = orderRef.id;
//       }

//       if (userId) {
//         await setDoc(doc(db, 'carts', userId), { items: {}, updatedAt: serverTimestamp() });
//       }
//       localStorage.removeItem('cartItems');
//       window.dispatchEvent(new Event('cartUpdated'));
//       window.dispatchEvent(new Event('refreshProfile'));

//       navigate('/order-confirmation', {
//         state: {
//           paymentMethod,
//           paymentId,
//           total: calculateTotal(),
//           subtotal: calculateSubtotal(),
//           couponDiscount,
//           pointsDiscount,
//           deliveryCharge,
//           deliveryDistance,
//           pointsEarned,
//           pointsUsed,
//           orderId,
//           firestoreOrderId,
//           customerName: name,
//           customerPhone: phone,
//           deliveryAddress
//         },
//       });
//     } catch (error) {
//       console.error('Error placing order:', error);
//       setError('Failed to place your order. Please try again.');
//     }
//   };

//   const handleCheckout = (e) => {
//     e.preventDefault();
//     setError('');

//     if (!validateForm()) {
//       setError('Please fill in all required fields correctly before placing your order.');
//       return;
//     }

//     if (cartItems.length === 0) {
//       setError('Your cart is empty.');
//       return;
//     }

//     if (paymentMethod === 'razorpay') {
//       handleRazorpayPayment();
//     } else {
//       // Process order directly
//       placeOrder();
//     }
//   };

//   const forceReloadCart = () => {
//     fetchCartFromLocalStorage();
//   };

//   const handleGoBack = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     navigate(-1, { replace: true });
//   };

//   const getDeliveryTitle = (speed) => {
//     switch (speed) {
//       case 'quick':
//         return 'Quick Delivery';
//       case 'express':
//         return 'Express Delivery';
//       case 'late':
//         return 'Eco Delivery';
//       case 'normal':
//       default:
//         return 'Standard Delivery';
//     }
//   };

//   const getDeliveryDisplayText = () => {
//     const subtotal = calculateSubtotal();

//     if (subtotal >= FREE_DELIVERY_THRESHOLD) {
//       return 'FREE';
//     }

//     if (isCalculatingDelivery) {
//       return 'Calculating...';
//     }

//     if (deliveryDistance > 0) {
//       return `${deliveryDistance.toFixed(1)} km × ₹${DELIVERY_RATE_PER_KM}`;
//     }

//     return 'Estimated';
//   };

//   if (loading) {
//     return (
//       <div className="checkout-loading">
//         <p>Loading your order details...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="checkout-container" style={{ minHeight: '100vh', padding: '20px', display: 'flex', flexDirection: 'column' }}>
//       <button className="go-back-btn2" onClick={handleGoBack}>
//         ← Go Back
//       </button>
//       <h2 className="checkout-title">Checkout</h2>
//       {error && <div className="checkout-error">{error}</div>}
//       <div className="checkout-content" style={{ flex: '1', display: 'flex', gap: '20px', maxHeight: 'calc(100vh + 600px)', overflow: 'hidden' }}>
//         <div className="checkout-summary" style={{ flex: '1', maxHeight: '100%', padding: '15px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '5px' }}>
//           <h3>Order Summary</h3>
//           {cartItems.length === 0 ? (
//             <div className="empty-cart-section">
//               <p>Your cart is empty.</p>
//               <button className="reload-cart-btn" onClick={forceReloadCart}>
//                 Reload Cart Items
//               </button>
//             </div>
//           ) : (
//             <div className="checkout-items" style={{ maxHeight: 'calc(100% - 100px)' }}>
//               {cartItems.map((item) => (
//                 <div key={item.id} className="checkout-item" style={{ marginBottom: '15px', padding: '10px', border: '1px solid #eee', borderRadius: '5px', display: 'flex', alignItems: 'center' }}>
//                   <img
//                     src={getImageUrl(item.imageUrl || item.image)}
//                     alt={item.name}
//                     className="checkout-item-image"
//                     style={{ width: '50px', height: '50px', marginRight: '10px' }}
//                     onError={(e) => {
//                       console.error("Image failed to load:", item.imageUrl || item.image);
//                       e.target.src = 'https://via.placeholder.com/50x50?text=Product';
//                     }}
//                   />
//                   <div className="checkout-item-details">
//                     <h4>{item.name}</h4>
//                     <p>
//                       ₹{(item.finalPrice || item.price || 0).toLocaleString('en-IN')} x {item.quantity || 1} = ₹
//                       {((item.finalPrice || item.price || 0) * (item.quantity || 1)).toLocaleString('en-IN')}
//                     </p>
//                     {item.deliverySurcharge > 0 && (
//                       <p className="delivery-surcharge">
//                         + Delivery Surcharge: ₹{item.deliverySurcharge.toLocaleString('en-IN')}
//                       </p>
//                     )}
//                     {item.deliverySpeed && (
//                       <div className="item-delivery-info">
//                         <span className={`delivery-badge ${item.deliverySpeed}`}>
//                           {getDeliveryTitle(item.deliverySpeed)}
//                         </span>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               ))}
//               <div className="checkout-total">
//                 <div className="summary-row">
//                   <span>Subtotal:</span>
//                   <span>₹{calculateSubtotal().toLocaleString('en-IN')}</span>
//                 </div>
                
//                 {/* Coupon discount */}
//                 {couponApplied && couponDiscount > 0 && (
//                   <div className="summary-row discount">
//                     <span>Coupon Discount (2%):</span>
//                     <span>-₹{couponDiscount.toLocaleString('en-IN')}</span>
//                   </div>
//                 )}
                
//                 {/* Points discount */}
//                 {pointsUsed > 0 && pointsDiscount > 0 && (
//                   <div className="summary-row points-discount">
//                     <span>Points Discount ({pointsUsed} points):</span>
//                     <span>-₹{pointsDiscount.toLocaleString('en-IN')}</span>
//                   </div>
//                 )}
                
//                 <div className="summary-row delivery-charge" style={{
//                   color: deliveryCharge === 0 ? 'green' : 'red',
//                   fontSize: '14px'
//                 }}>
//                   <span>
//                     Delivery Fee ({getDeliveryDisplayText()})
//                     {isCalculatingDelivery && <span className="calculating-spinner"> 🔄</span>}
//                   </span>
//                   <span>
//                     {deliveryCharge === 0 ? 'FREE' : `+₹${deliveryCharge.toLocaleString('en-IN')}`}
//                   </span>
//                 </div>
//                 {deliveryError && (
//                   <div className="delivery-error" style={{ fontSize: '12px', color: 'orange', marginTop: '5px' }}>
//                     {deliveryError}
//                   </div>
//                 )}

//                 <hr style={{ border: '1px dashed #ccc', margin: '10px 0' }} />
//                 <div className="summary-row total">
//                   <h4>Total:</h4>
//                   <span>₹{calculateTotal().toLocaleString('en-IN')}</span>
//                 </div>
//                 {pointsEarned > 0 && (
//                   <div className="summary-row points" style={{ color: 'green' }}>
//                     <span>Points Earned:</span>
//                     <span>{pointsEarned} points</span>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>

//         <div className="checkout-form" style={{ flex: '1', maxHeight: '100%', padding: '15px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '5px' }}>
//           <h3>Delivery Information</h3>
//           <form onSubmit={handleCheckout} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//             <div className="form-group">
//               <label htmlFor="name">Full Name *</label>
//               <input
//                 type="text"
//                 id="name"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//                 className={formErrors.name ? 'input-error' : ''}
//                 placeholder="Enter your full name"
//               />
//               {formErrors.name && <div className="error-message">{formErrors.name}</div>}
//             </div>

//             <div className="form-group">
//               <label htmlFor="phone">Phone Number *</label>
//               <input
//                 type="tel"
//                 id="phone"
//                 value={phone}
//                 onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
//                 className={formErrors.phone ? 'input-error' : ''}
//                 placeholder="10-digit mobile number"
//                 maxLength="10"
//               />
//               {formErrors.phone && <div className="error-message">{formErrors.phone}</div>}
//             </div>

//             <div className="form-group">
//               <label htmlFor="email">Email Address *</label>
//               <input
//                 type="email"
//                 id="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 className={formErrors.email ? 'input-error' : ''}
//                 placeholder="Enter your email address"
//               />
//               {formErrors.email && <div className="error-message">{formErrors.email}</div>}
//             </div>

//             <div className="form-group">
//               <label htmlFor="deliveryAddress">Delivery Address *</label>
//               <div className="address-input-container" style={{ position: 'relative' }}>
//                 <textarea
//                   id="deliveryAddress"
//                   value={deliveryAddress}
//                   onChange={(e) => setDeliveryAddress(e.target.value)}
//                   className={formErrors.deliveryAddress ? 'input-error' : ''}
//                   placeholder="Enter your complete delivery address (include area, landmark, city)"
//                   rows="3"
//                 />
//                 <div className="address-actions" style={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   marginTop: '8px',
//                   gap: '10px'
//                 }}>
//                   <button
//                     type="button"
//                     className="use-current-location-btn"
//                     onClick={handleUseCurrentLocation}
//                     disabled={isLocating}
//                     style={{
//                       flex: 1,
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       padding: '8px 12px',
//                       backgroundColor: '#f5f5f5',
//                       border: '1px solid #ddd',
//                       borderRadius: '4px',
//                       cursor: isLocating ? 'wait' : 'pointer',
//                       fontSize: '14px',
//                       color: '#333'
//                     }}
//                   >
//                     {isLocating ? (
//                       <>
//                         <span className="location-spinner" style={{
//                           display: 'inline-block',
//                           width: '16px',
//                           height: '16px',
//                           border: '2px solid rgba(0, 0, 0, 0.1)',
//                           borderTopColor: '#333',
//                           borderRadius: '50%',
//                           animation: 'spin 0.8s linear infinite',
//                           marginRight: '8px'
//                         }}></span>
//                         Detecting...
//                       </>
//                     ) : (
//                       <>
//                         <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '8px' }}>
//                           <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" />
//                         </svg>
//                         Use My Location
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </div>
//               {locationError && (
//                 <div className="location-error" style={{
//                   color: '#e53935',
//                   fontSize: '13px',
//                   marginTop: '5px',
//                   padding: '5px',
//                   backgroundColor: 'rgba(229, 57, 53, 0.1)',
//                   borderRadius: '4px'
//                 }}>
//                   {locationError}
//                 </div>
//               )}
//               {formErrors.deliveryAddress && <div className="error-message">{formErrors.deliveryAddress}</div>}
//               <div className="address-helper" style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
//                 💡 Tip: Include your area name, nearby landmark, and city for accurate delivery charges
//               </div>
//             </div>

//             <h3 className="section-title">Payment Method</h3>
//             <div className="payment-options">
//               <div
//                 className={`payment-option ${paymentMethod === 'razorpay' ? 'selected' : ''}`}
//                 onClick={() => setPaymentMethod('razorpay')}
//               >
//                 <div className="radio-container">
//                   <input
//                     type="radio"
//                     id="razorpay"
//                     name="paymentMethod"
//                     value="razorpay"
//                     checked={paymentMethod === 'razorpay'}
//                     onChange={(e) => setPaymentMethod(e.target.value)}
//                     className="radio-input"
//                   />
//                   <span className="radio-checkmark"></span>
//                 </div>
//                 <label htmlFor="razorpay" className="payment-label">Pay with Razorpay</label>
//               </div>
//             </div>
//             {formErrors.paymentMethod && <div className="error-message">{formErrors.paymentMethod}</div>}

//             <button
//               type="submit"
//               className="place-order-btn"
//               disabled={cartItems.length === 0 || !isFormValid || isCalculatingDelivery}
//               style={{
//                 padding: '10px 20px',
//                 width: '100%',
//                 marginTop: '15px',
//                 opacity: (cartItems.length === 0 || !isFormValid || isCalculatingDelivery) ? 0.6 : 1,
//                 cursor: (cartItems.length === 0 || !isFormValid || isCalculatingDelivery) ? 'not-allowed' : 'pointer'
//               }}
//             >
//               {isCalculatingDelivery ? 'Calculating Delivery...' : 'Place Order'}
//             </button>
//           </form>
//         </div>
//       </div>

//       {/* Add custom animation for location spinner */}
//       <style dangerouslySetInnerHTML={{
//         __html: `
//         @keyframes spin {
//           to {
//             transform: rotate(360deg);
//           }
//         }
        
//         .use-current-location-btn:hover {
//           background-color: #e9e9e9 !important;
//         }
        
//         .copy-address-btn:hover {
//           background-color: #e9e9e9 !important;
//         }
        
//         .location-spinner {
//           animation: spin 0.8s linear infinite;
//         }
        
//         .calculating-spinner {
//           display: inline-block;
//           animation: spin 1s linear infinite;
//         }
//       `}} />
//     </div>
//   );
// };

// export default Checkout;




// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   doc,
//   getDoc,
//   setDoc,
//   updateDoc,
//   collection,
//   addDoc,
//   serverTimestamp,
//   increment
// } from 'firebase/firestore';
// import { db, auth } from '../../firebase/firebaseConfig';
// import { onAuthStateChanged } from 'firebase/auth';
// import './Checkout.css';

// // Google Maps API key - using the same one from the Header component
// const GOOGLE_MAPS_API_KEY = 'AIzaSyA5ReIwel6soo1uIWWRvAIdIubZQKnbjfc';

// const Checkout = () => {
//   const [cartItems, setCartItems] = useState([]);
//   const [paymentMethod, setPaymentMethod] = useState('razorpay');
//   const [deliveryAddress, setDeliveryAddress] = useState('');
//   const [name, setName] = useState('');
//   const [phone, setPhone] = useState('');
//   const [email, setEmail] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [userId, setUserId] = useState(null);
//   const [userData, setUserData] = useState({});
//   const [formErrors, setFormErrors] = useState({});
//   const [isFormValid, setIsFormValid] = useState(false);
//   const navigate = useNavigate();
//   const [deliveryCharge, setDeliveryCharge] = useState(0);
//   const [pointsEarned, setPointsEarned] = useState(0);
//   const [deliveryDistance, setDeliveryDistance] = useState(0);
//   const [isCalculatingDelivery, setIsCalculatingDelivery] = useState(false);
//   const [deliveryError, setDeliveryError] = useState('');
  
//   // For coupon and points
//   const [couponApplied, setCouponApplied] = useState(false);
//   const [couponDiscount, setCouponDiscount] = useState(0);
//   const [pointsUsed, setPointsUsed] = useState(0);
//   const [pointsDiscount, setPointsDiscount] = useState(0);

//   // New state variables for location fetching
//   const [isLocating, setIsLocating] = useState(false);
//   const [locationError, setLocationError] = useState('');
//   const [fullAddressData, setFullAddressData] = useState(null);

//   const INVENTORY_LOCATION = "SP Road, Bangalore North, Bangalore, Karnataka 560002, India";
//   const DELIVERY_RATE_PER_KM = 45;
//   const BASE_DELIVERY_CHARGE = 50; // Minimum delivery charge
//   const MAX_DELIVERY_CHARGE = 500; // Maximum delivery charge
//   const FREE_DELIVERY_THRESHOLD = 2000; // Free delivery above this amount

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         setUserId(user.uid);
//         fetchUserData(user.uid);
//         fetchCartFromFirestore(user.uid);
//       } else {
//         setUserId(null);
//         fetchCartFromLocalStorage();
//         loadUserDataFromLocalStorage();
//       }
//     });
//     return () => unsubscribe();
//   }, []);

//   useEffect(() => {
//     const handleCartUpdate = () => {
//       console.log("Cart update detected in Checkout");
//       if (userId) {
//         fetchCartFromFirestore(userId);
//       } else {
//         fetchCartFromLocalStorage();
//       }
//     };
//     window.addEventListener('cartUpdated', handleCartUpdate);
//     return () => window.removeEventListener('cartUpdated', handleCartUpdate);
//   }, [userId]);

//   useEffect(() => {
//     validateForm();
//     calculatePointsEarned();
    
//     // Check coupon and points from cart items
//     if (cartItems.length > 0) {
//       // Check if any items have coupon applied
//       const anyCouponApplied = cartItems.some(item => item.couponApplied);
//       setCouponApplied(anyCouponApplied);
      
//       // Calculate coupon discount
//       if (anyCouponApplied) {
//         const subtotal = calculateSubtotal();
//         const discount = subtotal * 0.02; // 2% discount
//         setCouponDiscount(discount);
//       } else {
//         setCouponDiscount(0);
//       }
      
//       // Check for points used - IMPORTANT: use exact points from cart
//       const totalPointsUsed = cartItems.reduce((total, item) => {
//         return total + (item.pointsUsed || 0);
//       }, 0);
      
//       if (totalPointsUsed > 0) {
//         setPointsUsed(totalPointsUsed);
        
//         // Use exact points discount from cart (100 points = ₹1)
//         const discount = totalPointsUsed / 100;
//         setPointsDiscount(discount);
//         console.log(`Using ${totalPointsUsed} points for ₹${discount.toFixed(2)} discount from cart`);
//       } else {
//         setPointsUsed(0);
//         setPointsDiscount(0);
//       }
//     }
//   }, [name, phone, email, deliveryAddress, paymentMethod, cartItems]);

//   // Get detailed address from coordinates
//   const getDetailedAddressFromCoordinates = async (latitude, longitude) => {
//     try {
//       const response = await fetch(
//         `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_MAPS_API_KEY}`
//       );

//       if (!response.ok) {
//         throw new Error('Google Geocoding API error');
//       }

//       const data = await response.json();

//       if (data.status !== 'OK' || !data.results || data.results.length === 0) {
//         throw new Error('No address found for this location');
//       }

//       const fullResult = data.results[0];
//       const formattedAddress = fullResult.formatted_address;

//       // For a more concise display address in UI if needed
//       const displayAddress = formattedAddress.split(',').slice(0, 3).join(',');

//       return {
//         fullAddress: formattedAddress,
//         formattedAddress: formattedAddress, // Using full address for delivery
//         latitude,
//         longitude
//       };
//     } catch (googleError) {
//       console.error("Error with Google Geocoding:", googleError);
//       try {
//         // Fallback to another geocoding service
//         const response = await fetch(
//           `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
//         );

//         if (!response.ok) {
//           throw new Error('Geocoding API error');
//         }

//         const data = await response.json();
//         const locality = data.locality || '';
//         const district = data.localityInfo?.administrative?.find(a => a.adminLevel === 6)?.name || '';
//         const subDistrict = data.localityInfo?.administrative?.find(a => a.adminLevel === 8)?.name || '';
//         const road = data.road || '';
//         const street = data.street || '';
//         const city = data.city || data.locality || 'Bengaluru';
//         const state = data.principalSubdivision || 'Karnataka';
//         const country = data.countryName || 'India';
//         const postalCode = data.postcode || '';

//         // Construct a more complete address from the components
//         const addressComponents = [
//           road || street,
//           locality,
//           subDistrict,
//           district,
//           city,
//           state,
//           country,
//           postalCode
//         ].filter(Boolean);

//         const formattedAddress = addressComponents.join(', ');

//         return {
//           fullAddress: formattedAddress,
//           formattedAddress: formattedAddress,
//           latitude,
//           longitude,
//           city,
//           state
//         };
//       } catch (fallbackError) {
//         console.error("Error in fallback geocoding:", fallbackError);
//         throw new Error('Could not determine your location. Please try again or enter your address manually.');
//       }
//     }
//   };

//   // Handle using current location
//   const handleUseCurrentLocation = () => {
//     if (navigator.geolocation) {
//       setIsLocating(true);
//       setLocationError('');

//       navigator.geolocation.getCurrentPosition(
//         async (position) => {
//           try {
//             const { latitude, longitude } = position.coords;
//             const addressData = await getDetailedAddressFromCoordinates(latitude, longitude);

//             // Set address in form
//             setDeliveryAddress(addressData.fullAddress);
//             setFullAddressData(addressData);

//             // Store in localStorage for future use
//             try {
//               localStorage.setItem('userLocation', JSON.stringify(addressData));
//             } catch (error) {
//               console.error("Error saving to localStorage:", error);
//             }

//             setIsLocating(false);
//           } catch (error) {
//             console.error("Error getting detailed address:", error);
//             setLocationError(error.message);
//             setIsLocating(false);
//           }
//         },
//         (error) => {
//           console.error("Geolocation error:", error);
//           let errorMessage = 'Unable to detect location';

//           if (error.code === 1) {
//             errorMessage = 'Location access denied. Please enable location services.';
//           } else if (error.code === 2) {
//             errorMessage = 'Location unavailable. Please try again later.';
//           } else if (error.code === 3) {
//             errorMessage = 'Location request timed out. Please try again.';
//           }

//           setLocationError(errorMessage);
//           setIsLocating(false);
//         },
//         {
//           enableHighAccuracy: true,
//           timeout: 10000,
//           maximumAge: 0
//         }
//       );
//     } else {
//       setLocationError('Geolocation is not supported by your browser');
//     }
//   };

//   // Debounced delivery calculation
//   const calculateDeliveryCharges = useCallback(
//     debounce(async (address) => {
//       if (!address || !address.trim()) {
//         setDeliveryDistance(0);
//         setDeliveryCharge(0);
//         setDeliveryError('');
//         return;
//       }

//       setIsCalculatingDelivery(true);
//       setDeliveryError('');

//       try {
//         // First, try to calculate using a more reliable method
//         const distance = await calculateDistanceUsingGeocoding(address);

//         if (distance > 0) {
//           const calculatedCharge = calculateDeliveryFee(distance);
//           setDeliveryDistance(distance);
//           setDeliveryCharge(calculatedCharge);
//           console.log(`Distance: ${distance.toFixed(1)} km, Charge: ₹${calculatedCharge}`);
//         } else {
//           // Fallback to estimated charges based on location patterns
//           const estimatedCharge = estimateDeliveryCharge(address);
//           setDeliveryDistance(0);
//           setDeliveryCharge(estimatedCharge);

//         }
//       } catch (error) {
//         console.error('Error calculating delivery charges:', error);
//         const estimatedCharge = estimateDeliveryCharge(address);
//         setDeliveryDistance(0);
//         setDeliveryCharge(estimatedCharge);
//         setDeliveryError('Using estimated delivery charges due to calculation error.');
//       } finally {
//         setIsCalculatingDelivery(false);
//       }
//     }, 1000),
//     []
//   );

//   useEffect(() => {
//     if (deliveryAddress) {
//       calculateDeliveryCharges(deliveryAddress);
//     }
//   }, [deliveryAddress, calculateDeliveryCharges]);

//   // Debounce function
//   function debounce(func, wait) {
//     let timeout;
//     return function executedFunction(...args) {
//       const later = () => {
//         clearTimeout(timeout);
//         func(...args);
//       };
//       clearTimeout(timeout);
//       timeout = setTimeout(later, wait);
//     };
//   }

//   // More reliable distance calculation using geocoding
//   const calculateDistanceUsingGeocoding = async (address) => {
//     try {
//       // Use a geocoding service to get coordinates
//       const response = await fetch(
//         `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(address)}&key=YOUR_OPENCAGE_API_KEY&countrycode=IN&limit=1`
//       );

//       if (!response.ok) {
//         throw new Error('Geocoding service unavailable');
//       }

//       const data = await response.json();

//       if (data.results && data.results.length > 0) {
//         const { lat, lng } = data.results[0].geometry;

//         // SP Road coordinates (approximate)
//         const spRoadLat = 13.0067;
//         const spRoadLng = 77.5667;

//         const distance = calculateHaversineDistance(spRoadLat, spRoadLng, lat, lng);
//         return distance;
//       }

//       return 0;
//     } catch (error) {
//       console.error('Error in geocoding:', error);
//       return 0;
//     }
//   };

//   // Haversine formula for distance calculation
//   const calculateHaversineDistance = (lat1, lon1, lat2, lon2) => {
//     const R = 6371; // Radius of the Earth in kilometers
//     const dLat = (lat2 - lat1) * Math.PI / 180;
//     const dLon = (lon2 - lon1) * Math.PI / 180;
//     const a =
//       Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//       Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
//       Math.sin(dLon / 2) * Math.sin(dLon / 2);
//     const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//     const distance = R * c;
//     return distance;
//   };

//   // Calculate delivery fee based on distance
//   const calculateDeliveryFee = (distance) => {
//     const subtotal = calculateSubtotal();

//     // Free delivery for orders above threshold
//     if (subtotal >= FREE_DELIVERY_THRESHOLD) {
//       return 0;
//     }

//     let charge = Math.max(BASE_DELIVERY_CHARGE, Math.ceil(distance * DELIVERY_RATE_PER_KM));
//     return Math.min(charge, MAX_DELIVERY_CHARGE);
//   };

//   // Estimate delivery charge based on location patterns
//   const estimateDeliveryCharge = (address) => {
//     const subtotal = calculateSubtotal();

//     // Free delivery for orders above threshold
//     if (subtotal >= FREE_DELIVERY_THRESHOLD) {
//       return 0;
//     }

//     const lowerAddress = address.toLowerCase();

//     // Bangalore city center areas (closer to SP Road)
//     if (lowerAddress.includes('mg road') ||
//       lowerAddress.includes('brigade road') ||
//       lowerAddress.includes('commercial street') ||
//       lowerAddress.includes('chickpet') ||
//       lowerAddress.includes('gandhi nagar') ||
//       lowerAddress.includes('rajajinagar') ||
//       lowerAddress.includes('basavanagudi') ||
//       lowerAddress.includes('malleshwaram')) {
//       return 80;
//     }

//     // Nearby areas
//     if (lowerAddress.includes('koramangala') ||
//       lowerAddress.includes('indiranagar') ||
//       lowerAddress.includes('whitefield') ||
//       lowerAddress.includes('hsr layout') ||
//       lowerAddress.includes('btm layout') ||
//       lowerAddress.includes('jp nagar') ||
//       lowerAddress.includes('banashankari') ||
//       lowerAddress.includes('vijayanagar')) {
//       return 120;
//     }

//     // Outer Bangalore areas
//     if (lowerAddress.includes('electronic city') ||
//       lowerAddress.includes('sarjapur') ||
//       lowerAddress.includes('marathahalli') ||
//       lowerAddress.includes('hebbal') ||
//       lowerAddress.includes('yelahanka') ||
//       lowerAddress.includes('bommanahalli') ||
//       lowerAddress.includes('bannerghatta') ||
//       lowerAddress.includes('kengeri')) {
//       return 180;
//     }

//     // Default charge for other Bangalore areas
//     if (lowerAddress.includes('bangalore') ||
//       lowerAddress.includes('bengaluru') ||
//       lowerAddress.includes('karnataka')) {
//       return 150;
//     }

//     // Outside Bangalore
//     return 250;
//   };

//   const fetchUserData = async (uid) => {
//     try {
//       const userRef = doc(db, 'users', uid);
//       const userSnap = await getDoc(userRef);
//       if (userSnap.exists()) {
//         const data = userSnap.data();
//         setUserData(data);
//         setName(data.name || '');
//         setPhone(data.phone || '');
//         setEmail(data.email || '');
//         if (data.deliveryAddress) {
//           setDeliveryAddress(data.deliveryAddress);
//         } else {
//           loadDeliveryAddress();
//         }
//       } else {
//         console.log("No user data found");
//         loadDeliveryAddress();
//         loadUserDataFromLocalStorage();
//       }
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//       loadDeliveryAddress();
//       loadUserDataFromLocalStorage();
//     }
//   };

//   const loadDeliveryAddress = () => {
//     const savedLocation = localStorage.getItem('userLocation');
//     if (savedLocation) {
//       try {
//         const parsedLocation = JSON.parse(savedLocation);
//         setDeliveryAddress(parsedLocation.fullAddress || parsedLocation.formattedAddress || parsedLocation.address || '');
//         setFullAddressData(parsedLocation);
//       } catch (error) {
//         console.error('Error parsing delivery address:', error);
//         setDeliveryAddress('');
//       }
//     } else {
//       const savedAddress = localStorage.getItem('deliveryAddress');
//       if (savedAddress) {
//         setDeliveryAddress(savedAddress);
//       } else {
//         setDeliveryAddress('');
//       }
//     }
//   };

//   const loadUserDataFromLocalStorage = () => {
//     const savedUserData = localStorage.getItem('checkoutUserData');
//     if (savedUserData) {
//       try {
//         const parsedData = JSON.parse(savedUserData);
//         setName(parsedData.name || '');
//         setPhone(parsedData.phone || '');
//         setEmail(parsedData.email || '');
//       } catch (error) {
//         console.error('Error parsing user data from localStorage:', error);
//       }
//     }
//   };

//   const saveUserDataToLocalStorage = () => {
//     const dataToSave = { name, phone, email };
//     localStorage.setItem('checkoutUserData', JSON.stringify(dataToSave));
//     localStorage.setItem('deliveryAddress', deliveryAddress);
//   };

//   const saveUserDataToFirestore = async () => {
//     if (!userId) return;
//     try {
//       const userRef = doc(db, 'users', userId);
//       const userSnap = await getDoc(userRef);
//       if (userSnap.exists()) {
//         await updateDoc(userRef, {
//           name: name,
//           phone: phone,
//           email: email,
//           deliveryAddress: deliveryAddress,
//           updatedAt: serverTimestamp()
//         });
//       } else {
//         await setDoc(userRef, {
//           name: name,
//           phone: phone,
//           email: email,
//           deliveryAddress: deliveryAddress,
//           points: 0,
//           createdAt: serverTimestamp(),
//           updatedAt: serverTimestamp()
//         });
//       }
//     } catch (error) {
//       console.error('Error saving user data to Firestore:', error);
//     }
//   };

//   const fetchCartFromFirestore = async (uid) => {
//     try {
//       console.log("Fetching cart from Firestore");
//       const cartDocRef = doc(db, 'carts', uid);
//       const cartDoc = await getDoc(cartDocRef);
//       if (cartDoc.exists()) {
//         const cartData = cartDoc.data();
//         if (cartData.items && Object.keys(cartData.items).length > 0) {
//           const cartItemsArray = Object.values(cartData.items || {});
//           const validItems = cartItemsArray.map(item => ({
//             ...item,
//             finalPrice: item.finalPrice || item.price || item.originalPrice || 0,
//             pointsUsed: item.pointsUsed || 0,
//             pointsDiscount: item.pointsDiscount || 0,
//             couponApplied: item.couponApplied || false
//           })).filter(item => item && item.id && item.name);
          
//           console.log("Loaded items from Firestore for checkout:", validItems);
          
//           // Calculate total points used and discount
//           const totalPointsUsed = validItems.reduce((total, item) => total + (item.pointsUsed || 0), 0);
//           const pointsDiscount = totalPointsUsed / 100;
//           setPointsUsed(totalPointsUsed);
//           setPointsDiscount(pointsDiscount);
          
//           // Check if coupon is applied
//           const couponApplied = validItems.some(item => item.couponApplied);
//           setCouponApplied(couponApplied);
//           if (couponApplied) {
//             const subtotal = validItems.reduce((total, item) => 
//               total + (item.price * (item.quantity || 1)), 0);
//             setCouponDiscount(subtotal * 0.02); // 2% discount
//           }
          
//           setCartItems(validItems);
//         } else {
//           console.log("No items in Firestore cart, checking localStorage");
//           fetchCartFromLocalStorage();
//         }
//       } else {
//         console.log("Cart document does not exist in Firestore, checking localStorage");
//         fetchCartFromLocalStorage();
//       }
//     } catch (error) {
//       console.error('Error fetching cart from Firestore:', error);
//       fetchCartFromLocalStorage();
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchCartFromLocalStorage = () => {
//     console.log("Fetching cart from localStorage");
//     const storedCart = localStorage.getItem('cartItems');
//     console.log("Raw localStorage cart data:", storedCart);
//     if (storedCart) {
//       try {
//         const parsedCart = JSON.parse(storedCart);
//         let itemsToProcess = parsedCart;
//         if (!Array.isArray(parsedCart) && parsedCart && typeof parsedCart === 'object' && parsedCart.items) {
//           console.log("Found items property in localStorage cart object");
//           itemsToProcess = parsedCart.items;
//         }
//         if (!Array.isArray(itemsToProcess) && itemsToProcess && typeof itemsToProcess === 'object') {
//           console.log("Converting object to array from localStorage");
//           itemsToProcess = Object.values(itemsToProcess);
//         }
//         if (!Array.isArray(itemsToProcess)) {
//           console.log("itemsToProcess is not an array, setting to empty array");
//           itemsToProcess = [];
//         }
//         const validItems = itemsToProcess.map(item => ({
//           ...item,
//           finalPrice: item.finalPrice || item.price || item.originalPrice || 0,
//           pointsUsed: item.pointsUsed || 0,
//           pointsDiscount: item.pointsDiscount || 0,
//           couponApplied: item.couponApplied || false
//         })).filter(item => item && item.id && item.name);
        
//         console.log("Valid cart items from localStorage:", validItems);
        
//         // Calculate total points used and discount
//         const totalPointsUsed = validItems.reduce((total, item) => total + (item.pointsUsed || 0), 0);
//         const pointsDiscount = totalPointsUsed / 100;
//         setPointsUsed(totalPointsUsed);
//         setPointsDiscount(pointsDiscount);
        
//         // Check if coupon is applied
//         const couponApplied = validItems.some(item => item.couponApplied);
//         setCouponApplied(couponApplied);
//         if (couponApplied) {
//           const subtotal = validItems.reduce((total, item) => 
//             total + (item.price * (item.quantity || 1)), 0);
//           setCouponDiscount(subtotal * 0.02); // 2% discount
//         }
        
//         setCartItems(validItems);
//       } catch (error) {
//         console.error('Error parsing cart items from localStorage:', error);
//         setCartItems([]);
//       }
//     } else {
//       console.log("No cart items in localStorage");
//       setCartItems([]);
//     }
//     setLoading(false);
//   };

//   const validateForm = () => {
//     const errors = {};
//     let isValid = true;

//     if (!name.trim()) {
//       errors.name = 'Name is required';
//       isValid = false;
//     }

//     if (!phone.trim()) {
//       errors.phone = 'Phone number is required';
//       isValid = false;
//     } else if (!/^\d{10}$/.test(phone.trim())) {
//       errors.phone = 'Phone number must be 10 digits';
//       isValid = false;
//     }

//     if (!email.trim()) {
//       errors.email = 'Email is required';
//       isValid = false;
//     } else if (!/\S+@\S+\.\S+/.test(email.trim())) {
//       errors.email = 'Email is invalid';
//       isValid = false;
//     }

//     if (!deliveryAddress.trim()) {
//       errors.deliveryAddress = 'Delivery address is required';
//       isValid = false;
//     }

//     if (!paymentMethod) {
//       errors.paymentMethod = 'Please select a payment method';
//       isValid = false;
//     }

//     setFormErrors(errors);
//     setIsFormValid(isValid);
//     return isValid;
//   };

//   const getImageUrl = (image) => {
//     if (!image) return 'https://via.placeholder.com/50x50?text=Product';
//     if (typeof image === 'string' && image.startsWith('http')) return image;
//     if (typeof image === 'object' && image.hasOwnProperty('imageUrl')) return image.imageUrl;
//     return `/images/${image}`;
//   };

//   const calculatePointsEarned = () => {
//     if (!cartItems.length) {
//       setPointsEarned(0);
//       return;
//     }
//     const totalOriginalAmount = cartItems.reduce((total, item) => {
//       const originalPrice = item.originalPrice || item.price || 0;
//       const quantity = item.quantity || 1;
//       return total + (originalPrice * quantity);
//     }, 0);
//     const points = Math.floor(totalOriginalAmount / 10);
//     setPointsEarned(points);
//   };

//   const calculateSubtotal = () => {
//     return cartItems.reduce((total, item) => {
//       const itemPrice = item.finalPrice || item.price || item.originalPrice || 0;
//       const quantity = item.quantity || 1;
//       const deliverySurcharge = item.deliverySurcharge || 0;
//       return total + (itemPrice * quantity) + deliverySurcharge;
//     }, 0);
//   };

//   const calculateTotal = () => {
//     const subtotal = calculateSubtotal();
//     // Include coupon and points discounts in total calculation
//     return subtotal + deliveryCharge - couponDiscount - pointsDiscount;
//   };

//   const loadRazorpayScript = () => {
//     return new Promise((resolve) => {
//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   const handleRazorpayPayment = async () => {
//     const scriptLoaded = await loadRazorpayScript();
//     if (!scriptLoaded) {
//       setError('Failed to load Razorpay SDK. Please try again.');
//       return;
//     }

//     const totalAmount = calculateTotal() * 100;
//     const options = {
//       key: process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_psQiRu5RCF99Dp', // Using the correct test key
//       amount: totalAmount,
//       currency: 'INR',
//       name: 'ProCart India',
//       description: 'Order Payment',
//       handler: function (response) {
//         placeOrder(response.razorpay_payment_id);
//       },
//       prefill: { email, contact: phone, name },
//       theme: { color: '#4a90e2' },
//     };

//     const paymentObject = new window.Razorpay(options);
//     paymentObject.open();
//   };

//   const generateOrderId = () => {
//     const timestamp = new Date().getTime();
//     const randomPart = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
//     return `ORD-${timestamp}-${randomPart}`;
//   };

//   const placeOrder = async (paymentId = null) => {
//     try {
//       saveUserDataToLocalStorage();
//       if (userId) await saveUserDataToFirestore();

//       const orderId = generateOrderId();
//       const order = {
//         orderId,
//         items: cartItems,
//         subtotal: calculateSubtotal(),
//         couponApplied: couponApplied,
//         couponDiscount: couponDiscount,
//         pointsUsed: pointsUsed,
//         pointsDiscount: pointsDiscount,
//         deliveryCharge,
//         deliveryDistance,
//         totalAmount: calculateTotal(),
//         paymentMethod,
//         paymentId,
//         deliveryAddress,
//         customerName: name,
//         customerEmail: email,
//         customerPhone: phone,
//         pointsEarned,
//         orderDate: serverTimestamp(),
//         status: paymentMethod === 'cod' ? 'Pending Payment' : 'Processing',
//         userId: userId || 'guest',
//         createdAt: serverTimestamp(),
//         updatedAt: serverTimestamp()
//       };

//       let firestoreOrderId;
//       if (userId) {
//         const orderRef = await addDoc(collection(db, 'orders'), order);
//         firestoreOrderId = orderRef.id;
//         await setDoc(doc(db, 'users', userId, 'orders', orderRef.id), {
//           orderId: orderRef.id,
//           status: order.status,
//           totalAmount: order.totalAmount,
//           deliveryCharge: order.deliveryCharge,
//           deliveryDistance: order.deliveryDistance,
//           pointsEarned: order.pointsEarned,
//           orderDate: order.orderDate,
//           displayOrderId: orderId
//         });
        
//         // Update user points (deduct used points and add earned points)
//         const userRef = doc(db, 'users', userId);
//         if (pointsUsed > 0) {
//           // If points were used, deduct them and add new points
//           await updateDoc(userRef, {
//             points: increment(pointsEarned - pointsUsed),
//             updatedAt: serverTimestamp()
//           });
//         } else {
//           // Otherwise just add earned points
//           await updateDoc(userRef, {
//             points: increment(pointsEarned),
//             updatedAt: serverTimestamp()
//           });
//         }
//       } else {
//         const orderRef = await addDoc(collection(db, 'orders'), { ...order, userId: 'guest' });
//         firestoreOrderId = orderRef.id;
//       }

//       if (userId) {
//         await setDoc(doc(db, 'carts', userId), { items: {}, updatedAt: serverTimestamp() });
//       }
//       localStorage.removeItem('cartItems');
//       window.dispatchEvent(new Event('cartUpdated'));
//       window.dispatchEvent(new Event('refreshProfile'));

//       navigate('/order-confirmation', {
//         state: {
//           paymentMethod,
//           paymentId,
//           total: calculateTotal(),
//           subtotal: calculateSubtotal(),
//           couponDiscount,
//           pointsDiscount,
//           deliveryCharge,
//           deliveryDistance,
//           pointsEarned,
//           pointsUsed,
//           orderId,
//           firestoreOrderId,
//           customerName: name,
//           customerPhone: phone,
//           deliveryAddress
//         },
//       });
//     } catch (error) {
//       console.error('Error placing order:', error);
//       setError('Failed to place your order. Please try again.');
//     }
//   };

//   const handleCheckout = (e) => {
//     e.preventDefault();
//     setError('');

//     if (!validateForm()) {
//       setError('Please fill in all required fields correctly before placing your order.');
//       return;
//     }

//     if (cartItems.length === 0) {
//       setError('Your cart is empty.');
//       return;
//     }

//     if (paymentMethod === 'razorpay') {
//       handleRazorpayPayment();
//     } else {
//       // Process order directly
//       placeOrder();
//     }
//   };

//   const forceReloadCart = () => {
//     fetchCartFromLocalStorage();
//   };

//   const handleGoBack = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     navigate(-1, { replace: true });
//   };

//   const getDeliveryTitle = (speed) => {
//     switch (speed) {
//       case 'quick':
//         return 'Quick Delivery';
//       case 'express':
//         return 'Express Delivery';
//       case 'late':
//         return 'Eco Delivery';
//       case 'normal':
//       default:
//         return 'Standard Delivery';
//     }
//   };

//   const getDeliveryDisplayText = () => {
//     const subtotal = calculateSubtotal();

//     if (subtotal >= FREE_DELIVERY_THRESHOLD) {
//       return 'FREE';
//     }

//     if (isCalculatingDelivery) {
//       return 'Calculating...';
//     }

//     if (deliveryDistance > 0) {
//       return `${deliveryDistance.toFixed(1)} km × ₹${DELIVERY_RATE_PER_KM}`;
//     }

//     return '';
//   };

//   if (loading) {
//     return (
//       <div className="checkout-loading">
//         <p>Loading your order details...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="checkout-container" style={{ 
//       minHeight: '100vh', 
//       padding: '15px', 
//       display: 'flex', 
//       flexDirection: 'column',
//       backgroundColor: '#f9f9f9' 
//     }}>
//       <button 
//         className="go-back-btn2" 
//         onClick={handleGoBack} 
//         style={{
//           background: 'none',
//           border: 'none',
//           color: '#4a90e2',
//           fontSize: '14px',
//           padding: '5px 0',
//           marginBottom: '10px',
//           cursor: 'pointer',
//           display: 'flex',
//           alignItems: 'center'
//         }}
//       >
//         ← Go Back
//       </button>
      
//       <h2 className="checkout-title" style={{ margin: '0 0 15px 0' }}>Checkout</h2>
      
//       {error && (
//         <div className="checkout-error" style={{
//           color: '#e53935',
//           padding: '10px',
//           marginBottom: '15px',
//           backgroundColor: 'rgba(229, 57, 53, 0.1)',
//           borderRadius: '4px',
//           fontSize: '14px'
//         }}>
//           {error}
//         </div>
//       )}
      
//       {/* Mobile-friendly vertical layout */}
//       <div className="checkout-content" style={{
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '15px',
//         width: '100%'
//       }}>
//         {/* Order Summary Section */}
//         <div className="checkout-summary" style={{
//           padding: '15px',
//           border: '1px solid #ddd',
//           borderRadius: '8px',
//           backgroundColor: 'white',
//           boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
//         }}>
//           <h3 style={{ marginTop: '0', marginBottom: '15px' }}>Order Summary</h3>
          
//           {cartItems.length === 0 ? (
//             <div className="empty-cart-section" style={{ textAlign: 'center', padding: '20px 0' }}>
//               <p>Your cart is empty.</p>
//               <button 
//                 className="reload-cart-btn" 
//                 onClick={forceReloadCart}
//                 style={{
//                   padding: '8px 15px',
//                   backgroundColor: '#f0f0f0',
//                   border: '1px solid #ddd',
//                   borderRadius: '4px',
//                   cursor: 'pointer',
//                   fontSize: '14px'
//                 }}
//               >
//                 Reload Cart Items
//               </button>
//             </div>
//           ) : (
//             <div className="checkout-items">
//               {cartItems.map((item) => (
//                 <div 
//                   key={item.id} 
//                   className="checkout-item" 
//                   style={{ 
//                     marginBottom: '12px',
//                     padding: '10px',
//                     border: '1px solid #eee',
//                     borderRadius: '5px',
//                     display: 'flex',
//                     alignItems: 'center'
//                   }}
//                 >
//                   <img
//                     src={getImageUrl(item.imageUrl || item.image)}
//                     alt={item.name}
//                     className="checkout-item-image"
//                     style={{ width: '50px', height: '50px', marginRight: '10px', borderRadius: '4px' }}
//                     onError={(e) => {
//                       console.error("Image failed to load:", item.imageUrl || item.image);
//                       e.target.src = 'https://via.placeholder.com/50x50?text=Product';
//                     }}
//                   />
//                   <div className="checkout-item-details" style={{ flex: 1 }}>
//                     <h4 style={{ margin: '0 0 5px 0', fontSize: '14px' }}>{item.name}</h4>
//                     <p style={{ margin: '0 0 5px 0', fontSize: '13px' }}>
//                       ₹{(item.finalPrice || item.price || 0).toLocaleString('en-IN')} x {item.quantity || 1} = ₹
//                       {((item.finalPrice || item.price || 0) * (item.quantity || 1)).toLocaleString('en-IN')}
//                     </p>
//                     {item.deliverySurcharge > 0 && (
//                       <p className="delivery-surcharge" style={{ 
//                         margin: '0 0 5px 0', 
//                         fontSize: '12px',
//                         color: '#e53935'
//                       }}>
//                         + Delivery Surcharge: ₹{item.deliverySurcharge.toLocaleString('en-IN')}
//                       </p>
//                     )}
//                     {item.deliverySpeed && (
//                       <div className="item-delivery-info">
//                         <span className={`delivery-badge ${item.deliverySpeed}`} style={{
//                           display: 'inline-block',
//                           padding: '2px 6px',
//                           fontSize: '11px',
//                           borderRadius: '3px',
//                           backgroundColor: item.deliverySpeed === 'express' ? '#4caf50' : 
//                                           item.deliverySpeed === 'quick' ? '#2196f3' : 
//                                           item.deliverySpeed === 'late' ? '#ff9800' : '#9e9e9e',
//                           color: 'white'
//                         }}>
//                           {getDeliveryTitle(item.deliverySpeed)}
//                         </span>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               ))}
              
//               <div className="checkout-total" style={{ fontSize: '14px' }}>
//                 <div className="summary-row" style={{ 
//                   display: 'flex', 
//                   justifyContent: 'space-between',
//                   margin: '5px 0'
//                 }}>
//                   <span>Subtotal:</span>
//                   <span>₹{calculateSubtotal().toLocaleString('en-IN')}</span>
//                 </div>
                
//                 {/* Coupon discount */}
//                 {couponApplied && couponDiscount > 0 && (
//                   <div className="summary-row discount" style={{ 
//                     display: 'flex', 
//                     justifyContent: 'space-between',
//                     margin: '5px 0',
//                     color: 'green'
//                   }}>
//                     <span>Coupon Discount (2%):</span>
//                     <span>-₹{couponDiscount.toLocaleString('en-IN')}</span>
//                   </div>
//                 )}
                
//                 {/* Points discount */}
//                 {pointsUsed > 0 && pointsDiscount > 0 && (
//                   <div className="summary-row points-discount" style={{ 
//                     display: 'flex', 
//                     justifyContent: 'space-between',
//                     margin: '5px 0',
//                     color: 'green'
//                   }}>
//                     <span>Points Discount ({pointsUsed} points):</span>
//                     <span>-₹{pointsDiscount.toLocaleString('en-IN')}</span>
//                   </div>
//                 )}
                
//                 <div className="summary-row delivery-charge" style={{
//                   display: 'flex', 
//                   justifyContent: 'space-between',
//                   margin: '5px 0',
//                   color: deliveryCharge === 0 ? 'green' : 'red',
//                   fontSize: '14px'
//                 }}>
//                   <span>
//                     Delivery Fee ({getDeliveryDisplayText()})
//                     {isCalculatingDelivery && <span className="calculating-spinner"> 🔄</span>}
//                   </span>
//                   <span>
//                     {deliveryCharge === 0 ? 'FREE' : `+₹${deliveryCharge.toLocaleString('en-IN')}`}
//                   </span>
//                 </div>
                
//                 {deliveryError && (
//                   <div className="delivery-error" style={{ 
//                     fontSize: '12px', 
//                     color: 'orange', 
//                     marginTop: '5px' 
//                   }}>
//                     {deliveryError}
//                   </div>
//                 )}

//                 <hr style={{ border: '1px dashed #ccc', margin: '10px 0' }} />
                
//                 <div className="summary-row total" style={{ 
//                   display: 'flex', 
//                   justifyContent: 'space-between',
//                   margin: '5px 0',
//                   fontWeight: 'bold',
//                   fontSize: '16px'
//                 }}>
//                   <span>Total:</span>
//                   <span>₹{calculateTotal().toLocaleString('en-IN')}</span>
//                 </div>
                
//                 {pointsEarned > 0 && (
//                   <div className="summary-row points" style={{ 
//                     display: 'flex', 
//                     justifyContent: 'space-between',
//                     margin: '5px 0',
//                     color: 'green',
//                     fontSize: '13px'
//                   }}>
//                     <span>Points Earned:</span>
//                     <span>{pointsEarned} points</span>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Delivery Information Section */}
//         <div className="checkout-form" style={{
//           padding: '15px',
//           border: '1px solid #ddd',
//           borderRadius: '8px',
//           backgroundColor: 'white',
//           boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
//         }}>
//           <h3 style={{ marginTop: '0', marginBottom: '15px' }}>Delivery Information</h3>
          
//           <form onSubmit={handleCheckout} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//             <div className="form-group" style={{ marginBottom: '15px' }}>
//               <label htmlFor="name" style={{ 
//                 display: 'block', 
//                 marginBottom: '5px',
//                 fontSize: '14px',
//                 fontWeight: '500'
//               }}>
//                 Full Name *
//               </label>
//               <input
//                 type="text"
//                 id="name"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//                 className={formErrors.name ? 'input-error' : ''}
//                 placeholder="Enter your full name"
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   border: formErrors.name ? '1px solid #e53935' : '1px solid #ddd',
//                   borderRadius: '4px',
//                   fontSize: '14px'
//                 }}
//               />
//               {formErrors.name && (
//                 <div className="error-message" style={{ 
//                   color: '#e53935',
//                   fontSize: '12px',
//                   marginTop: '4px'
//                 }}>
//                   {formErrors.name}
//                 </div>
//               )}
//             </div>

//             <div className="form-group" style={{ marginBottom: '15px' }}>
//               <label htmlFor="phone" style={{ 
//                 display: 'block', 
//                 marginBottom: '5px',
//                 fontSize: '14px',
//                 fontWeight: '500'
//               }}>
//                 Phone Number *
//               </label>
//               <input
//                 type="tel"
//                 id="phone"
//                 value={phone}
//                 onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
//                 className={formErrors.phone ? 'input-error' : ''}
//                 placeholder="10-digit mobile number"
//                 maxLength="10"
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   border: formErrors.phone ? '1px solid #e53935' : '1px solid #ddd',
//                   borderRadius: '4px',
//                   fontSize: '14px'
//                 }}
//               />
//               {formErrors.phone && (
//                 <div className="error-message" style={{ 
//                   color: '#e53935',
//                   fontSize: '12px',
//                   marginTop: '4px'
//                 }}>
//                   {formErrors.phone}
//                 </div>
//               )}
//             </div>

//             <div className="form-group" style={{ marginBottom: '15px' }}>
//               <label htmlFor="email" style={{ 
//                 display: 'block', 
//                 marginBottom: '5px',
//                 fontSize: '14px',
//                 fontWeight: '500'
//               }}>
//                 Email Address *
//               </label>
//               <input
//                 type="email"
//                 id="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 className={formErrors.email ? 'input-error' : ''}
//                 placeholder="Enter your email address"
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   border: formErrors.email ? '1px solid #e53935' : '1px solid #ddd',
//                   borderRadius: '4px',
//                   fontSize: '14px'
//                 }}
//               />
//               {formErrors.email && (
//                 <div className="error-message" style={{ 
//                   color: '#e53935',
//                   fontSize: '12px',
//                   marginTop: '4px'
//                 }}>
//                   {formErrors.email}
//                 </div>
//               )}
//             </div>

//             <div className="form-group" style={{ marginBottom: '15px' }}>
//               <label htmlFor="deliveryAddress" style={{ 
//                 display: 'block', 
//                 marginBottom: '5px',
//                 fontSize: '14px',
//                 fontWeight: '500'
//               }}>
//                 Delivery Address *
//               </label>
//               <div className="address-input-container" style={{ position: 'relative' }}>
//                 <textarea
//                   id="deliveryAddress"
//                   value={deliveryAddress}
//                   onChange={(e) => setDeliveryAddress(e.target.value)}
//                   className={formErrors.deliveryAddress ? 'input-error' : ''}
//                   placeholder="Enter your complete delivery address (include area, landmark, city)"
//                   rows="3"
//                   style={{
//                     width: '100%',
//                     padding: '10px',
//                     border: formErrors.deliveryAddress ? '1px solid #e53935' : '1px solid #ddd',
//                     borderRadius: '4px',
//                     fontSize: '14px',
//                     resize: 'vertical'
//                   }}
//                 />
//                 <div className="address-actions" style={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   marginTop: '8px',
//                   gap: '10px'
//                 }}>
//                   <button
//                     type="button"
//                     className="use-current-location-btn"
//                     onClick={handleUseCurrentLocation}
//                     disabled={isLocating}
//                     style={{
//                       flex: 1,
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       padding: '8px 12px',
//                       backgroundColor: '#f5f5f5',
//                       border: '1px solid #ddd',
//                       borderRadius: '4px',
//                       cursor: isLocating ? 'wait' : 'pointer',
//                       fontSize: '14px',
//                       color: '#333'
//                     }}
//                   >
//                     {isLocating ? (
//                       <>
//                         <span className="location-spinner" style={{
//                           display: 'inline-block',
//                           width: '16px',
//                           height: '16px',
//                           border: '2px solid rgba(0, 0, 0, 0.1)',
//                           borderTopColor: '#333',
//                           borderRadius: '50%',
//                           animation: 'spin 0.8s linear infinite',
//                           marginRight: '8px'
//                         }}></span>
//                         Detecting...
//                       </>
//                     ) : (
//                       <>
//                         <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '8px' }}>
//                           <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" />
//                         </svg>
//                         Use My Location
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </div>
//               {locationError && (
//                 <div className="location-error" style={{
//                   color: '#e53935',
//                   fontSize: '13px',
//                   marginTop: '5px',
//                   padding: '5px',
//                   backgroundColor: 'rgba(229, 57, 53, 0.1)',
//                   borderRadius: '4px'
//                 }}>
//                   {locationError}
//                 </div>
//               )}
//               {formErrors.deliveryAddress && (
//                 <div className="error-message" style={{ 
//                   color: '#e53935',
//                   fontSize: '12px',
//                   marginTop: '4px'
//                 }}>
//                   {formErrors.deliveryAddress}
//                 </div>
//               )}
//               <div className="address-helper" style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
//                 💡 Tip: Include your area name, nearby landmark, and city for accurate delivery charges
//               </div>
//             </div>

//             <h3 className="section-title" style={{ 
//               marginTop: '10px', 
//               marginBottom: '10px',
//               fontSize: '16px'
//             }}>
//               Payment Method
//             </h3>
            
//             <div className="payment-options">
//               <div
//                 className={`payment-option ${paymentMethod === 'razorpay' ? 'selected' : ''}`}
//                 onClick={() => setPaymentMethod('razorpay')}
//                 style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   padding: '10px',
//                   border: '1px solid #4a90e2',
//                   borderRadius: '4px',
//                   cursor: 'pointer',
//                   backgroundColor: '#f0f7ff'
//                 }}
//               >
//                 <div className="radio-container" style={{ marginRight: '10px' }}>
//                   <div style={{ 
//                     width: '20px', 
//                     height: '20px', 
//                     borderRadius: '50%', 
//                     border: '2px solid #4a90e2',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center'
//                   }}>
//                     {paymentMethod === 'razorpay' && (
//                       <div style={{ 
//                         width: '12px', 
//                         height: '12px', 
//                         borderRadius: '50%', 
//                         backgroundColor: '#4a90e2'
//                       }}></div>
//                     )}
//                   </div>
//                 </div>
//                 <label htmlFor="razorpay" className="payment-label" style={{ 
//                   flex: 1, 
//                   cursor: 'pointer',
//                   fontSize: '14px'
//                 }}>
//                   Pay with Razorpay
//                 </label>
//               </div>
//             </div>
            
//             {formErrors.paymentMethod && (
//               <div className="error-message" style={{ 
//                 color: '#e53935',
//                 fontSize: '12px',
//                 marginTop: '4px'
//               }}>
//                 {formErrors.paymentMethod}
//               </div>
//             )}

//             <button
//               type="submit"
//               className="place-order-btn"
//               disabled={cartItems.length === 0 || !isFormValid || isCalculatingDelivery}
//               style={{
//                 padding: '12px 20px',
//                 width: '100%',
//                 marginTop: '15px',
//                 marginBottom: '15px',
//                 backgroundColor: (cartItems.length === 0 || !isFormValid || isCalculatingDelivery) ? '#cccccc' : '#4a90e2',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '4px',
//                 fontSize: '16px',
//                 fontWeight: '600',
//                 cursor: (cartItems.length === 0 || !isFormValid || isCalculatingDelivery) ? 'not-allowed' : 'pointer',
//                 opacity: (cartItems.length === 0 || !isFormValid || isCalculatingDelivery) ? 0.7 : 1,
//               }}
//             >
//               {isCalculatingDelivery ? 'Calculating Delivery...' : 'Place Order'}
//             </button>
//           </form>
//         </div>
//       </div>

//       {/* Add custom animation for location spinner */}
//       <style dangerouslySetInnerHTML={{
//         __html: `
//         @keyframes spin {
//           to {
//             transform: rotate(360deg);
//           }
//         }
        
//         .use-current-location-btn:hover {
//           background-color: #e9e9e9 !important;
//         }
        
//         .copy-address-btn:hover {
//           background-color: #e9e9e9 !important;
//         }
        
//         .location-spinner {
//           animation: spin 0.8s linear infinite;
//         }
        
//         .calculating-spinner {
//           display: inline-block;
//           animation: spin 1s linear infinite;
//         }
        
//         /* Add responsive styles for different screen sizes */
//         @media (min-width: 768px) {
//           .checkout-content {
//             flex-direction: row;
//             align-items: flex-start;
//             gap: 20px;
//           }
          
//           .checkout-summary,
//           .checkout-form {
//             flex: 1;
//           }
//         }
        
//         /* Fix for iPhones and smaller devices */
//         @media (max-width: 767px) {
//           .checkout-container {
//             padding: 10px;
//           }
          
//           .checkout-summary, 
//           .checkout-form {
//             padding: 10px;
//           }
//         }
//       `}} />
//     </div>
//   );
// };

// export default Checkout;




import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  collection,
  addDoc,
  serverTimestamp,
  increment,
  Timestamp
} from 'firebase/firestore';
import { db, auth } from '../../firebase/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import './Checkout.css';

// Google Maps API key - using the same one from the Header component
const GOOGLE_MAPS_API_KEY = 'AIzaSyA5ReIwel6soo1uIWWRvAIdIubZQKnbjfc';

const Checkout = () => {
  const [cartItems, setCartItems] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState('razorpay');
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [userData, setUserData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);
  const navigate = useNavigate();
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [pointsEarned, setPointsEarned] = useState(0);
  const [deliveryDistance, setDeliveryDistance] = useState(0);
  const [isCalculatingDelivery, setIsCalculatingDelivery] = useState(false);
  const [deliveryError, setDeliveryError] = useState('');
  
  // For coupon and points
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [pointsUsed, setPointsUsed] = useState(0);
  const [pointsDiscount, setPointsDiscount] = useState(0);

  // New state variables for location fetching
  const [isLocating, setIsLocating] = useState(false);
  const [locationError, setLocationError] = useState('');
  const [fullAddressData, setFullAddressData] = useState(null);

  const INVENTORY_LOCATION = "SP Road, Bangalore North, Bangalore, Karnataka 560002, India";
  const DELIVERY_RATE_PER_KM = 45;
  const BASE_DELIVERY_CHARGE = 50; // Minimum delivery charge
  const MAX_DELIVERY_CHARGE = 500; // Maximum delivery charge
  const FREE_DELIVERY_THRESHOLD = 2000; // Free delivery above this amount

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid);
        fetchUserData(user.uid);
        fetchCartFromFirestore(user.uid);
      } else {
        setUserId(null);
        fetchCartFromLocalStorage();
        loadUserDataFromLocalStorage();
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const handleCartUpdate = () => {
      console.log("Cart update detected in Checkout");
      if (userId) {
        fetchCartFromFirestore(userId);
      } else {
        fetchCartFromLocalStorage();
      }
    };
    window.addEventListener('cartUpdated', handleCartUpdate);
    return () => window.removeEventListener('cartUpdated', handleCartUpdate);
  }, [userId]);

  useEffect(() => {
    validateForm();
    calculatePointsEarned();
    
    // Check coupon and points from cart items
    if (cartItems.length > 0) {
      // Check if any items have coupon applied
      const anyCouponApplied = cartItems.some(item => item.couponApplied);
      setCouponApplied(anyCouponApplied);
      
      // Calculate coupon discount
      if (anyCouponApplied) {
        const subtotal = calculateSubtotal();
        const discount = subtotal * 0.02; // 2% discount
        setCouponDiscount(discount);
      } else {
        setCouponDiscount(0);
      }
      
      // Check for points used - IMPORTANT: use exact points from cart
      const totalPointsUsed = cartItems.reduce((total, item) => {
        return total + (item.pointsUsed || 0);
      }, 0);
      
      if (totalPointsUsed > 0) {
        setPointsUsed(totalPointsUsed);
        
        // Use exact points discount from cart (100 points = ₹1)
        const discount = totalPointsUsed / 100;
        setPointsDiscount(discount);
        console.log(`Using ${totalPointsUsed} points for ₹${discount.toFixed(2)} discount from cart`);
      } else {
        setPointsUsed(0);
        setPointsDiscount(0);
      }
    }
  }, [name, phone, email, deliveryAddress, paymentMethod, cartItems]);

  // Get detailed address from coordinates
  const getDetailedAddressFromCoordinates = async (latitude, longitude) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_MAPS_API_KEY}`
      );

      if (!response.ok) {
        throw new Error('Google Geocoding API error');
      }

      const data = await response.json();

      if (data.status !== 'OK' || !data.results || data.results.length === 0) {
        throw new Error('No address found for this location');
      }

      const fullResult = data.results[0];
      const formattedAddress = fullResult.formatted_address;

      // For a more concise display address in UI if needed
      const displayAddress = formattedAddress.split(',').slice(0, 3).join(',');

      return {
        fullAddress: formattedAddress,
        formattedAddress: formattedAddress, // Using full address for delivery
        latitude,
        longitude
      };
    } catch (googleError) {
      console.error("Error with Google Geocoding:", googleError);
      try {
        // Fallback to another geocoding service
        const response = await fetch(
          `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
        );

        if (!response.ok) {
          throw new Error('Geocoding API error');
        }

        const data = await response.json();
        const locality = data.locality || '';
        const district = data.localityInfo?.administrative?.find(a => a.adminLevel === 6)?.name || '';
        const subDistrict = data.localityInfo?.administrative?.find(a => a.adminLevel === 8)?.name || '';
        const road = data.road || '';
        const street = data.street || '';
        const city = data.city || data.locality || 'Bengaluru';
        const state = data.principalSubdivision || 'Karnataka';
        const country = data.countryName || 'India';
        const postalCode = data.postcode || '';

        // Construct a more complete address from the components
        const addressComponents = [
          road || street,
          locality,
          subDistrict,
          district,
          city,
          state,
          country,
          postalCode
        ].filter(Boolean);

        const formattedAddress = addressComponents.join(', ');

        return {
          fullAddress: formattedAddress,
          formattedAddress: formattedAddress,
          latitude,
          longitude,
          city,
          state
        };
      } catch (fallbackError) {
        console.error("Error in fallback geocoding:", fallbackError);
        throw new Error('Could not determine your location. Please try again or enter your address manually.');
      }
    }
  };

  // Handle using current location
  const handleUseCurrentLocation = () => {
    if (navigator.geolocation) {
      setIsLocating(true);
      setLocationError('');

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const { latitude, longitude } = position.coords;
            const addressData = await getDetailedAddressFromCoordinates(latitude, longitude);

            // Set address in form
            setDeliveryAddress(addressData.fullAddress);
            setFullAddressData(addressData);

            // Store in localStorage for future use
            try {
              localStorage.setItem('userLocation', JSON.stringify(addressData));
            } catch (error) {
              console.error("Error saving to localStorage:", error);
            }

            setIsLocating(false);
          } catch (error) {
            console.error("Error getting detailed address:", error);
            setLocationError(error.message);
            setIsLocating(false);
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
          let errorMessage = 'Unable to detect location';

          if (error.code === 1) {
            errorMessage = 'Location access denied. Please enable location services.';
          } else if (error.code === 2) {
            errorMessage = 'Location unavailable. Please try again later.';
          } else if (error.code === 3) {
            errorMessage = 'Location request timed out. Please try again.';
          }

          setLocationError(errorMessage);
          setIsLocating(false);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    } else {
      setLocationError('Geolocation is not supported by your browser');
    }
  };

  // Debounced delivery calculation
  const calculateDeliveryCharges = useCallback(
    debounce(async (address) => {
      if (!address || !address.trim()) {
        setDeliveryDistance(0);
        setDeliveryCharge(0);
        setDeliveryError('');
        return;
      }

      setIsCalculatingDelivery(true);
      setDeliveryError('');

      try {
        // First, try to calculate using a more reliable method
        const distance = await calculateDistanceUsingGeocoding(address);

        if (distance > 0) {
          const calculatedCharge = calculateDeliveryFee(distance);
          setDeliveryDistance(distance);
          setDeliveryCharge(calculatedCharge);
          console.log(`Distance: ${distance.toFixed(1)} km, Charge: ₹${calculatedCharge}`);
        } else {
          // Fallback to estimated charges based on location patterns
          const estimatedCharge = estimateDeliveryCharge(address);
          setDeliveryDistance(0);
          setDeliveryCharge(estimatedCharge);

        }
      } catch (error) {
        console.error('Error calculating delivery charges:', error);
        const estimatedCharge = estimateDeliveryCharge(address);
        setDeliveryDistance(0);
        setDeliveryCharge(estimatedCharge);
        setDeliveryError('Using estimated delivery charges due to calculation error.');
      } finally {
        setIsCalculatingDelivery(false);
      }
    }, 1000),
    []
  );

  useEffect(() => {
    if (deliveryAddress) {
      calculateDeliveryCharges(deliveryAddress);
    }
  }, [deliveryAddress, calculateDeliveryCharges]);

  // Debounce function
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // More reliable distance calculation using geocoding
  const calculateDistanceUsingGeocoding = async (address) => {
    try {
      // Use a geocoding service to get coordinates
      const response = await fetch(
        `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(address)}&key=YOUR_OPENCAGE_API_KEY&countrycode=IN&limit=1`
      );

      if (!response.ok) {
        throw new Error('Geocoding service unavailable');
      }

      const data = await response.json();

      if (data.results && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry;

        // SP Road coordinates (approximate)
        const spRoadLat = 13.0067;
        const spRoadLng = 77.5667;

        const distance = calculateHaversineDistance(spRoadLat, spRoadLng, lat, lng);
        return distance;
      }

      return 0;
    } catch (error) {
      console.error('Error in geocoding:', error);
      return 0;
    }
  };

  // Haversine formula for distance calculation
  const calculateHaversineDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return distance;
  };

  // Calculate delivery fee based on distance
  const calculateDeliveryFee = (distance) => {
    const subtotal = calculateSubtotal();

    // Free delivery for orders above threshold
    if (subtotal >= FREE_DELIVERY_THRESHOLD) {
      return 0;
    }

    let charge = Math.max(BASE_DELIVERY_CHARGE, Math.ceil(distance * DELIVERY_RATE_PER_KM));
    return Math.min(charge, MAX_DELIVERY_CHARGE);
  };

  // Estimate delivery charge based on location patterns
  const estimateDeliveryCharge = (address) => {
    const subtotal = calculateSubtotal();

    // Free delivery for orders above threshold
    if (subtotal >= FREE_DELIVERY_THRESHOLD) {
      return 0;
    }

    const lowerAddress = address.toLowerCase();

    // Bangalore city center areas (closer to SP Road)
    if (lowerAddress.includes('mg road') ||
      lowerAddress.includes('brigade road') ||
      lowerAddress.includes('commercial street') ||
      lowerAddress.includes('chickpet') ||
      lowerAddress.includes('gandhi nagar') ||
      lowerAddress.includes('rajajinagar') ||
      lowerAddress.includes('basavanagudi') ||
      lowerAddress.includes('malleshwaram')) {
      return 80;
    }

    // Nearby areas
    if (lowerAddress.includes('koramangala') ||
      lowerAddress.includes('indiranagar') ||
      lowerAddress.includes('whitefield') ||
      lowerAddress.includes('hsr layout') ||
      lowerAddress.includes('btm layout') ||
      lowerAddress.includes('jp nagar') ||
      lowerAddress.includes('banashankari') ||
      lowerAddress.includes('vijayanagar')) {
      return 120;
    }

    // Outer Bangalore areas
    if (lowerAddress.includes('electronic city') ||
      lowerAddress.includes('sarjapur') ||
      lowerAddress.includes('marathahalli') ||
      lowerAddress.includes('hebbal') ||
      lowerAddress.includes('yelahanka') ||
      lowerAddress.includes('bommanahalli') ||
      lowerAddress.includes('bannerghatta') ||
      lowerAddress.includes('kengeri')) {
      return 180;
    }

    // Default charge for other Bangalore areas
    if (lowerAddress.includes('bangalore') ||
      lowerAddress.includes('bengaluru') ||
      lowerAddress.includes('karnataka')) {
      return 150;
    }

    // Outside Bangalore
    return 250;
  };

  const fetchUserData = async (uid) => {
    try {
      const userRef = doc(db, 'users', uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        const data = userSnap.data();
        setUserData(data);
        setName(data.name || '');
        setPhone(data.phone || '');
        setEmail(data.email || '');
        if (data.deliveryAddress) {
          setDeliveryAddress(data.deliveryAddress);
        } else {
          loadDeliveryAddress();
        }
      } else {
        console.log("No user data found");
        loadDeliveryAddress();
        loadUserDataFromLocalStorage();
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      loadDeliveryAddress();
      loadUserDataFromLocalStorage();
    }
  };

  const loadDeliveryAddress = () => {
    const savedLocation = localStorage.getItem('userLocation');
    if (savedLocation) {
      try {
        const parsedLocation = JSON.parse(savedLocation);
        setDeliveryAddress(parsedLocation.fullAddress || parsedLocation.formattedAddress || parsedLocation.address || '');
        setFullAddressData(parsedLocation);
      } catch (error) {
        console.error('Error parsing delivery address:', error);
        setDeliveryAddress('');
      }
    } else {
      const savedAddress = localStorage.getItem('deliveryAddress');
      if (savedAddress) {
        setDeliveryAddress(savedAddress);
      } else {
        setDeliveryAddress('');
      }
    }
  };

  const loadUserDataFromLocalStorage = () => {
    const savedUserData = localStorage.getItem('checkoutUserData');
    if (savedUserData) {
      try {
        const parsedData = JSON.parse(savedUserData);
        setName(parsedData.name || '');
        setPhone(parsedData.phone || '');
        setEmail(parsedData.email || '');
      } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
      }
    }
  };

  const saveUserDataToLocalStorage = () => {
    const dataToSave = { name, phone, email };
    localStorage.setItem('checkoutUserData', JSON.stringify(dataToSave));
    localStorage.setItem('deliveryAddress', deliveryAddress);
  };

  const saveUserDataToFirestore = async () => {
    if (!userId) return;
    try {
      const userRef = doc(db, 'users', userId);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        await updateDoc(userRef, {
          name: name,
          phone: phone,
          email: email,
          deliveryAddress: deliveryAddress,
          updatedAt: serverTimestamp()
        });
      } else {
        await setDoc(userRef, {
          name: name,
          phone: phone,
          email: email,
          deliveryAddress: deliveryAddress,
          points: 0,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        });
      }
    } catch (error) {
      console.error('Error saving user data to Firestore:', error);
    }
  };

  const fetchCartFromFirestore = async (uid) => {
    try {
      console.log("Fetching cart from Firestore");
      const cartDocRef = doc(db, 'carts', uid);
      const cartDoc = await getDoc(cartDocRef);
      if (cartDoc.exists()) {
        const cartData = cartDoc.data();
        if (cartData.items && Object.keys(cartData.items).length > 0) {
          const cartItemsArray = Object.values(cartData.items || {});
          const validItems = cartItemsArray.map(item => ({
            ...item,
            finalPrice: item.finalPrice || item.price || item.originalPrice || 0,
            pointsUsed: item.pointsUsed || 0,
            pointsDiscount: item.pointsDiscount || 0,
            couponApplied: item.couponApplied || false
          })).filter(item => item && item.id && item.name);
          
          console.log("Loaded items from Firestore for checkout:", validItems);
          
          // Calculate total points used and discount
          const totalPointsUsed = validItems.reduce((total, item) => total + (item.pointsUsed || 0), 0);
          const pointsDiscount = totalPointsUsed / 100;
          setPointsUsed(totalPointsUsed);
          setPointsDiscount(pointsDiscount);
          
          // Check if coupon is applied
          const couponApplied = validItems.some(item => item.couponApplied);
          setCouponApplied(couponApplied);
          if (couponApplied) {
            const subtotal = validItems.reduce((total, item) => 
              total + (item.price * (item.quantity || 1)), 0);
            setCouponDiscount(subtotal * 0.02); // 2% discount
          }
          
          setCartItems(validItems);
        } else {
          console.log("No items in Firestore cart, checking localStorage");
          fetchCartFromLocalStorage();
        }
      } else {
        console.log("Cart document does not exist in Firestore, checking localStorage");
        fetchCartFromLocalStorage();
      }
    } catch (error) {
      console.error('Error fetching cart from Firestore:', error);
      fetchCartFromLocalStorage();
    } finally {
      setLoading(false);
    }
  };

  const fetchCartFromLocalStorage = () => {
    console.log("Fetching cart from localStorage");
    const storedCart = localStorage.getItem('cartItems');
    console.log("Raw localStorage cart data:", storedCart);
    if (storedCart) {
      try {
        const parsedCart = JSON.parse(storedCart);
        let itemsToProcess = parsedCart;
        if (!Array.isArray(parsedCart) && parsedCart && typeof parsedCart === 'object' && parsedCart.items) {
          console.log("Found items property in localStorage cart object");
          itemsToProcess = parsedCart.items;
        }
        if (!Array.isArray(itemsToProcess) && itemsToProcess && typeof itemsToProcess === 'object') {
          console.log("Converting object to array from localStorage");
          itemsToProcess = Object.values(itemsToProcess);
        }
        if (!Array.isArray(itemsToProcess)) {
          console.log("itemsToProcess is not an array, setting to empty array");
          itemsToProcess = [];
        }
        const validItems = itemsToProcess.map(item => ({
          ...item,
          finalPrice: item.finalPrice || item.price || item.originalPrice || 0,
          pointsUsed: item.pointsUsed || 0,
          pointsDiscount: item.pointsDiscount || 0,
          couponApplied: item.couponApplied || false
        })).filter(item => item && item.id && item.name);
        
        console.log("Valid cart items from localStorage:", validItems);
        
        // Calculate total points used and discount
        const totalPointsUsed = validItems.reduce((total, item) => total + (item.pointsUsed || 0), 0);
        const pointsDiscount = totalPointsUsed / 100;
        setPointsUsed(totalPointsUsed);
        setPointsDiscount(pointsDiscount);
        
        // Check if coupon is applied
        const couponApplied = validItems.some(item => item.couponApplied);
        setCouponApplied(couponApplied);
        if (couponApplied) {
          const subtotal = validItems.reduce((total, item) => 
            total + (item.price * (item.quantity || 1)), 0);
          setCouponDiscount(subtotal * 0.02); // 2% discount
        }
        
        setCartItems(validItems);
      } catch (error) {
        console.error('Error parsing cart items from localStorage:', error);
        setCartItems([]);
      }
    } else {
      console.log("No cart items in localStorage");
      setCartItems([]);
    }
    setLoading(false);
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    if (!name.trim()) {
      errors.name = 'Name is required';
      isValid = false;
    }

    if (!phone.trim()) {
      errors.phone = 'Phone number is required';
      isValid = false;
    } else if (!/^\d{10}$/.test(phone.trim())) {
      errors.phone = 'Phone number must be 10 digits';
      isValid = false;
    }

    if (!email.trim()) {
      errors.email = 'Email is required';
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email.trim())) {
      errors.email = 'Email is invalid';
      isValid = false;
    }

    if (!deliveryAddress.trim()) {
      errors.deliveryAddress = 'Delivery address is required';
      isValid = false;
    }

    if (!paymentMethod) {
      errors.paymentMethod = 'Please select a payment method';
      isValid = false;
    }

    setFormErrors(errors);
    setIsFormValid(isValid);
    return isValid;
  };

  const getImageUrl = (image) => {
    if (!image) return 'https://via.placeholder.com/50x50?text=Product';
    if (typeof image === 'string' && image.startsWith('http')) return image;
    if (typeof image === 'object' && image.hasOwnProperty('imageUrl')) return image.imageUrl;
    return `/images/${image}`;
  };

  const calculatePointsEarned = () => {
    if (!cartItems.length) {
      setPointsEarned(0);
      return;
    }
    const totalOriginalAmount = cartItems.reduce((total, item) => {
      const originalPrice = item.originalPrice || item.price || 0;
      const quantity = item.quantity || 1;
      return total + (originalPrice * quantity);
    }, 0);
    const points = Math.floor(totalOriginalAmount / 10);
    setPointsEarned(points);
  };

  const calculateSubtotal = () => {
    return cartItems.reduce((total, item) => {
      const itemPrice = item.finalPrice || item.price || item.originalPrice || 0;
      const quantity = item.quantity || 1;
      return total + (itemPrice * quantity);
    }, 0);
  };

  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    // Include coupon and points discounts in total calculation
    return subtotal + deliveryCharge - couponDiscount - pointsDiscount;
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleRazorpayPayment = async () => {
    const scriptLoaded = await loadRazorpayScript();
    if (!scriptLoaded) {
      setError('Failed to load Razorpay SDK. Please try again.');
      return;
    }

    const totalAmount = calculateTotal() * 100;
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_psQiRu5RCF99Dp', // Using the correct test key
      amount: totalAmount,
      currency: 'INR',
      name: 'ProCart India',
      description: 'Order Payment',
      handler: function (response) {
        placeOrder(response.razorpay_payment_id);
      },
      prefill: { email, contact: phone, name },
      theme: { color: '#4a90e2' },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  const generateOrderId = () => {
    const timestamp = new Date().getTime();
    const randomPart = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
    return `ORD-${timestamp}-${randomPart}`;
  };

  // Calculate next business day's delivery date (9 AM to 4 PM)
  const calculateNextDayDeliveryWindow = () => {
    // Get tomorrow's date
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    
    // Set delivery window start (9 AM)
    const deliveryStart = new Date(tomorrow);
    deliveryStart.setHours(9, 0, 0, 0);
    
    // Set delivery window end (4 PM)
    const deliveryEnd = new Date(tomorrow);
    deliveryEnd.setHours(16, 0, 0, 0);
    
    return {
      scheduledDate: tomorrow,
      deliveryWindowStart: deliveryStart,
      deliveryWindowEnd: deliveryEnd,
      deliveryDateFormatted: tomorrow.toLocaleDateString('en-IN', { 
        weekday: 'long', 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      }),
      deliveryTimeFormatted: '9:00 AM - 4:00 PM'
    };
  };

  const placeOrder = async (paymentId = null) => {
    try {
      saveUserDataToLocalStorage();
      if (userId) await saveUserDataToFirestore();

      // Calculate next day's delivery window
      const deliverySchedule = calculateNextDayDeliveryWindow();
      
      const orderId = generateOrderId();
      const order = {
        orderId,
        items: cartItems,
        subtotal: calculateSubtotal(),
        couponApplied: couponApplied,
        couponDiscount: couponDiscount,
        pointsUsed: pointsUsed,
        pointsDiscount: pointsDiscount,
        deliveryCharge,
        deliveryDistance,
        totalAmount: calculateTotal(),
        paymentMethod,
        paymentId,
        deliveryAddress,
        customerName: name,
        customerEmail: email,
        customerPhone: phone,
        pointsEarned,
        orderDate: serverTimestamp(),
        status: paymentMethod === 'cod' ? 'Pending Payment' : 'Processing',
        userId: userId || 'guest',
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        // Add delivery schedule information
        scheduledDeliveryDate: Timestamp.fromDate(deliverySchedule.scheduledDate),
        deliveryWindowStart: Timestamp.fromDate(deliverySchedule.deliveryWindowStart),
        deliveryWindowEnd: Timestamp.fromDate(deliverySchedule.deliveryWindowEnd),
        deliveryDateFormatted: deliverySchedule.deliveryDateFormatted,
        deliveryTimeFormatted: deliverySchedule.deliveryTimeFormatted
      };

      let firestoreOrderId;
      if (userId) {
        const orderRef = await addDoc(collection(db, 'orders'), order);
        firestoreOrderId = orderRef.id;
        await setDoc(doc(db, 'users', userId, 'orders', orderRef.id), {
          orderId: orderRef.id,
          status: order.status,
          totalAmount: order.totalAmount,
          deliveryCharge: order.deliveryCharge,
          deliveryDistance: order.deliveryDistance,
          pointsEarned: order.pointsEarned,
          orderDate: order.orderDate,
          displayOrderId: orderId,
          scheduledDeliveryDate: order.scheduledDeliveryDate,
          deliveryWindowStart: order.deliveryWindowStart,
          deliveryWindowEnd: order.deliveryWindowEnd,
          deliveryDateFormatted: order.deliveryDateFormatted,
          deliveryTimeFormatted: order.deliveryTimeFormatted
        });
        
        // Update user points (deduct used points and add earned points)
        const userRef = doc(db, 'users', userId);
        if (pointsUsed > 0) {
          // If points were used, deduct them and add new points
          await updateDoc(userRef, {
            points: increment(pointsEarned - pointsUsed),
            updatedAt: serverTimestamp()
          });
        } else {
          // Otherwise just add earned points
          await updateDoc(userRef, {
            points: increment(pointsEarned),
            updatedAt: serverTimestamp()
          });
        }
      } else {
        const orderRef = await addDoc(collection(db, 'orders'), { ...order, userId: 'guest' });
        firestoreOrderId = orderRef.id;
      }

      if (userId) {
        await setDoc(doc(db, 'carts', userId), { items: {}, updatedAt: serverTimestamp() });
      }
      localStorage.removeItem('cartItems');
      window.dispatchEvent(new Event('cartUpdated'));
      window.dispatchEvent(new Event('refreshProfile'));

      navigate('/order-confirmation', {
        state: {
          paymentMethod,
          paymentId,
          total: calculateTotal(),
          subtotal: calculateSubtotal(),
          couponDiscount,
          pointsDiscount,
          deliveryCharge,
          deliveryDistance,
          pointsEarned,
          pointsUsed,
          orderId,
          firestoreOrderId,
          customerName: name,
          customerPhone: phone,
          deliveryAddress,
          // Include delivery schedule in navigation state
          scheduledDeliveryDate: deliverySchedule.scheduledDate,
          deliveryDateFormatted: deliverySchedule.deliveryDateFormatted,
          deliveryTimeFormatted: deliverySchedule.deliveryTimeFormatted
        },
      });
    } catch (error) {
      console.error('Error placing order:', error);
      setError('Failed to place your order. Please try again.');
    }
  };

  const handleCheckout = (e) => {
    e.preventDefault();
    setError('');

    if (!validateForm()) {
      setError('Please fill in all required fields correctly before placing your order.');
      return;
    }

    if (cartItems.length === 0) {
      setError('Your cart is empty.');
      return;
    }

    if (paymentMethod === 'razorpay') {
      handleRazorpayPayment();
    } else {
      // Process order directly
      placeOrder();
    }
  };

  const forceReloadCart = () => {
    fetchCartFromLocalStorage();
  };

  const handleGoBack = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(-1, { replace: true });
  };

  const getDeliveryTitle = (speed) => {
    return 'Standard Delivery'; // All items use standard delivery
  };

  const getDeliveryDisplayText = () => {
    const subtotal = calculateSubtotal();

    if (subtotal >= FREE_DELIVERY_THRESHOLD) {
      return 'FREE';
    }

    if (isCalculatingDelivery) {
      return 'Calculating...';
    }

    if (deliveryDistance > 0) {
      return `${deliveryDistance.toFixed(1)} km × ₹${DELIVERY_RATE_PER_KM}`;
    }

    return 'Estimated';
  };

  if (loading) {
    return (
      <div className="checkout-loading">
        <p>Loading your order details...</p>
      </div>
    );
  }

  // Get next day delivery info for display
  const nextDayDelivery = calculateNextDayDeliveryWindow();

  return (
    <div className="checkout-container" style={{ 
      minHeight: '100vh', 
      padding: '15px', 
      display: 'flex', 
      flexDirection: 'column',
      backgroundColor: '#f9f9f9' 
    }}>
      <button 
        className="go-back-btn2" 
        onClick={handleGoBack} 
        style={{
          background: 'none',
          border: 'none',
          color: '#4a90e2',
          fontSize: '14px',
          padding: '5px 0',
          marginBottom: '10px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        ← Go Back
      </button>
      
      <h2 className="checkout-title" style={{ margin: '0 0 15px 0' }}>Checkout</h2>
      
      {error && (
        <div className="checkout-error" style={{
          color: '#e53935',
          padding: '10px',
          marginBottom: '15px',
          backgroundColor: 'rgba(229, 57, 53, 0.1)',
          borderRadius: '4px',
          fontSize: '14px'
        }}>
          {error}
        </div>
      )}
      
      
      {/* Mobile-friendly vertical layout */}
      <div className="checkout-content" style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '15px',
        width: '100%'
      }}>
        {/* Order Summary Section */}
        <div className="checkout-summary" style={{
          padding: '15px',
          border: '1px solid #ddd',
          borderRadius: '8px',
          backgroundColor: 'white',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{ marginTop: '0', marginBottom: '15px' }}>Order Summary</h3>
          
          {cartItems.length === 0 ? (
            <div className="empty-cart-section" style={{ textAlign: 'center', padding: '20px 0' }}>
              <p>Your cart is empty.</p>
              <button 
                className="reload-cart-btn" 
                onClick={forceReloadCart}
                style={{
                  padding: '8px 15px',
                  backgroundColor: '#f0f0f0',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Reload Cart Items
              </button>
            </div>
          ) : (
            <div className="checkout-items">
              {cartItems.map((item) => (
                <div 
                  key={item.id} 
                  className="checkout-item" 
                  style={{ 
                    marginBottom: '12px',
                    padding: '10px',
                    border: '1px solid #eee',
                    borderRadius: '5px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <img
                    src={getImageUrl(item.imageUrl || item.image)}
                    alt={item.name}
                    className="checkout-item-image"
                    style={{ width: '50px', height: '50px', marginRight: '10px', borderRadius: '4px' }}
                    onError={(e) => {
                      console.error("Image failed to load:", item.imageUrl || item.image);
                      e.target.src = 'https://via.placeholder.com/50x50?text=Product';
                    }}
                  />
                  <div className="checkout-item-details" style={{ flex: 1 }}>
                    <h4 style={{ margin: '0 0 5px 0', fontSize: '14px' }}>{item.name}</h4>
                    <p style={{ margin: '0 0 5px 0', fontSize: '13px' }}>
                      ₹{(item.finalPrice || item.price || 0).toLocaleString('en-IN')} x {item.quantity || 1} = ₹
                      {((item.finalPrice || item.price || 0) * (item.quantity || 1)).toLocaleString('en-IN')}
                    </p>
                  </div>
                </div>
              ))}
              
              <div className="checkout-total" style={{ fontSize: '14px' }}>
                <div className="summary-row" style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between',
                  margin: '5px 0'
                }}>
                  <span>Subtotal:</span>
                  <span>₹{calculateSubtotal().toLocaleString('en-IN')}</span>
                </div>
                
                {/* Coupon discount */}
                {couponApplied && couponDiscount > 0 && (
                  <div className="summary-row discount" style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    margin: '5px 0',
                    color: 'green'
                  }}>
                    <span>Coupon Discount (2%):</span>
                    <span>-₹{couponDiscount.toLocaleString('en-IN')}</span>
                  </div>
                )}
                
                {/* Points discount */}
                {pointsUsed > 0 && pointsDiscount > 0 && (
                  <div className="summary-row points-discount" style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    margin: '5px 0',
                    color: 'green'
                  }}>
                    <span>Points Discount ({pointsUsed} points):</span>
                    <span>-₹{pointsDiscount.toLocaleString('en-IN')}</span>
                  </div>
                )}
                
                <div className="summary-row checkout-delivery-fee" style={{
                  display: 'flex', 
                  justifyContent: 'space-between',
                  margin: '5px 0',
                  color: deliveryCharge === 0 ? 'green' : 'red',
                  fontSize: '14px'
                }}>
                  <span>
                    Delivery Fee
                    {isCalculatingDelivery && <span className="calculating-spinner"> 🔄</span>}
                  </span>
                  <span>
                    {deliveryCharge === 0 ? 'FREE' : `+₹${deliveryCharge.toLocaleString('en-IN')}`}
                  </span>
                </div>
                
                {deliveryError && (
                  <div className="delivery-error" style={{ 
                    fontSize: '12px', 
                    color: 'orange', 
                    marginTop: '5px' 
                  }}>
                    {deliveryError}
                  </div>
                )}

                <hr style={{ border: '1px dashed #ccc', margin: '10px 0' }} />
                
                <div className="summary-row total" style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between',
                  margin: '5px 0',
                  fontWeight: 'bold',
                  fontSize: '16px'
                }}>
                  <span>Total:</span>
                  <span>₹{calculateTotal().toLocaleString('en-IN')}</span>
                </div>
                
                {pointsEarned > 0 && (
                  <div className="summary-row points" style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    margin: '5px 0',
                    color: 'green',
                    fontSize: '13px'
                  }}>
                    <span>Points Earned:</span>
                    <span>{pointsEarned} points</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Delivery Information Section */}
        <div className="checkout-form" style={{
          padding: '15px',
          border: '1px solid #ddd',
          borderRadius: '8px',
          backgroundColor: 'white',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{ marginTop: '0', marginBottom: '15px' }}>Delivery Information</h3>
          
          <form onSubmit={handleCheckout} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label htmlFor="name" style={{ 
                display: 'block', 
                marginBottom: '5px',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                Full Name *
              </label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className={formErrors.name ? 'input-error' : ''}
                placeholder="Enter your full name"
                style={{
                  width: '100%',
                  padding: '10px',
                  border: formErrors.name ? '1px solid #e53935' : '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}
              />
              {formErrors.name && (
                <div className="error-message" style={{ 
                  color: '#e53935',
                  fontSize: '12px',
                  marginTop: '4px'
                }}>
                  {formErrors.name}
                </div>
              )}
            </div>

            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label htmlFor="phone" style={{ 
                display: 'block', 
                marginBottom: '5px',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                Phone Number *
              </label>
              <input
                type="tel"
                id="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
                className={formErrors.phone ? 'input-error' : ''}
                placeholder="10-digit mobile number"
                maxLength="10"
                style={{
                  width: '100%',
                  padding: '10px',
                  border: formErrors.phone ? '1px solid #e53935' : '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}
              />
              {formErrors.phone && (
                <div className="error-message" style={{ 
                  color: '#e53935',
                  fontSize: '12px',
                  marginTop: '4px'
                }}>
                  {formErrors.phone}
                </div>
              )}
            </div>

            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label htmlFor="email" style={{ 
                display: 'block', 
                marginBottom: '5px',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                Email Address *
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={formErrors.email ? 'input-error' : ''}
                placeholder="Enter your email address"
                style={{
                  width: '100%',
                  padding: '10px',
                  border: formErrors.email ? '1px solid #e53935' : '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}
              />
              {formErrors.email && (
                <div className="error-message" style={{ 
                  color: '#e53935',
                  fontSize: '12px',
                  marginTop: '4px'
                }}>
                  {formErrors.email}
                </div>
              )}
            </div>

            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label htmlFor="deliveryAddress" style={{ 
                display: 'block', 
                marginBottom: '5px',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                Delivery Address *
              </label>
              <div className="address-input-container" style={{ position: 'relative' }}>
                <textarea
                  id="deliveryAddress"
                  value={deliveryAddress}
                  onChange={(e) => setDeliveryAddress(e.target.value)}
                  className={formErrors.deliveryAddress ? 'input-error' : ''}
                  placeholder="Enter your complete delivery address (include area, landmark, city)"
                  rows="3"
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: formErrors.deliveryAddress ? '1px solid #e53935' : '1px solid #ddd',
                    borderRadius: '4px',
                    fontSize: '14px',
                    resize: 'vertical'
                  }}
                />
                <div className="address-actions" style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: '8px',
                  gap: '10px'
                }}>
                  <button
                    type="button"
                    className="use-current-location-btn"
                    onClick={handleUseCurrentLocation}
                    disabled={isLocating}
                    style={{
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '8px 12px',
                      backgroundColor: '#f5f5f5',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      cursor: isLocating ? 'wait' : 'pointer',
                      fontSize: '14px',
                      color: '#333'
                    }}
                  >
                    {isLocating ? (
                      <>
                        <span className="location-spinner" style={{
                          display: 'inline-block',
                          width: '16px',
                          height: '16px',
                          border: '2px solid rgba(0, 0, 0, 0.1)',
                          borderTopColor: '#333',
                          borderRadius: '50%',
                          animation: 'spin 0.8s linear infinite',
                          marginRight: '8px'
                        }}></span>
                        Detecting...
                      </>
                    ) : (
                      <>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '8px' }}>
                          <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" />
                        </svg>
                        Use My Location
                      </>
                    )}
                  </button>
                </div>
              </div>
              {locationError && (
                <div className="location-error" style={{
                  color: '#e53935',
                  fontSize: '13px',
                  marginTop: '5px',
                  padding: '5px',
                  backgroundColor: 'rgba(229, 57, 53, 0.1)',
                  borderRadius: '4px'
                }}>
                  {locationError}
                </div>
              )}
              {formErrors.deliveryAddress && (
                <div className="error-message" style={{ 
                  color: '#e53935',
                  fontSize: '12px',
                  marginTop: '4px'
                }}>
                  {formErrors.deliveryAddress}
                </div>
              )}
              <div className="address-helper" style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                💡 Tip: Include your area name, nearby landmark, and city for accurate delivery charges
              </div>
            </div>

            <h3 className="section-title" style={{ 
              marginTop: '10px', 
              marginBottom: '10px',
              fontSize: '16px'
            }}>
              Payment Method
            </h3>
            
            <div className="payment-options">
              <div
                className={`payment-option ${paymentMethod === 'razorpay' ? 'selected' : ''}`}
                onClick={() => setPaymentMethod('razorpay')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '10px',
                  border: '1px solid #4a90e2',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  backgroundColor: '#f0f7ff'
                }}
              >
                <div className="radio-container" style={{ marginRight: '10px' }}>
                  <div style={{ 
                    width: '20px', 
                    height: '20px', 
                    borderRadius: '50%', 
                    border: '2px solid #4a90e2',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                    {paymentMethod === 'razorpay' && (
                      <div style={{ 
                        width: '12px', 
                        height: '12px', 
                        borderRadius: '50%', 
                        backgroundColor: '#4a90e2'
                      }}></div>
                    )}
                  </div>
                </div>
                <label htmlFor="razorpay" className="payment-label" style={{ 
                  flex: 1, 
                  cursor: 'pointer',
                  fontSize: '14px'
                }}>
                  Pay with Razorpay
                </label>
              </div>
            </div>
            
            {formErrors.paymentMethod && (
              <div className="error-message" style={{ 
                color: '#e53935',
                fontSize: '12px',
                marginTop: '4px'
              }}>
                {formErrors.paymentMethod}
              </div>
            )}

            <button
              type="submit"
              className="place-order-btn"
              disabled={cartItems.length === 0 || !isFormValid || isCalculatingDelivery}
              style={{
                padding: '12px 20px',
                width: '100%',
                marginTop: '15px',
                marginBottom: '15px',
                backgroundColor: (cartItems.length === 0 || !isFormValid || isCalculatingDelivery) ? '#cccccc' : '#4a90e2',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: (cartItems.length === 0 || !isFormValid || isCalculatingDelivery) ? 'not-allowed' : 'pointer',
                opacity: (cartItems.length === 0 || !isFormValid || isCalculatingDelivery) ? 0.7 : 1,
              }}
            >
              {isCalculatingDelivery ? 'Calculating Delivery...' : 'Place Order'}
            </button>
          </form>
        </div>
      </div>

      {/* Add custom animation for location spinner */}
      <style dangerouslySetInnerHTML={{
        __html: `
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
        
        .use-current-location-btn:hover {
          background-color: #e9e9e9 !important;
        }
        
        .copy-address-btn:hover {
          background-color: #e9e9e9 !important;
        }
        
        .location-spinner {
          animation: spin 0.8s linear infinite;
        }
        
        .calculating-spinner {
          display: inline-block;
          animation: spin 1s linear infinite;
        }
        
        /* Add responsive styles for different screen sizes */
        @media (min-width: 768px) {
          .checkout-content {
            flex-direction: row;
            align-items: flex-start;
            gap: 20px;
          }
          
          .checkout-summary,
          .checkout-form {
            flex: 1;
          }
        }
        
        /* Fix for iPhones and smaller devices */
        @media (max-width: 767px) {
          .checkout-container {
            padding: 10px;
          }
          
          .checkout-summary, 
          .checkout-form {
            padding: 10px;
          }
        }
      `}} />
    </div>
  );
};

export default Checkout;